import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header-left"
}
const _hoisted_2 = {
  key: 1,
  class: "header-left page-status"
}
const _hoisted_3 = {
  key: 0,
  class: "idle-hint"
}
const _hoisted_4 = { class: "header-center" }
const _hoisted_5 = {
  key: 0,
  class: "selected-count cashbook"
}
const _hoisted_6 = { class: "total-price" }
const _hoisted_7 = {
  key: 1,
  class: "match-arrow"
}
const _hoisted_8 = {
  key: 2,
  class: "selected-count receipt"
}
const _hoisted_9 = {
  key: 0,
  class: "page-info"
}
const _hoisted_10 = { class: "header-right" }
const _hoisted_11 = { class: "matching-content" }
const _hoisted_12 = { class: "cashbook-panel" }
const _hoisted_13 = { class: "panel-header centered" }
const _hoisted_14 = {
  key: 0,
  class: "count"
}
const _hoisted_15 = { class: "cashbook-tabs" }
const _hoisted_16 = { class: "tab-count" }
const _hoisted_17 = { class: "tab-count" }
const _hoisted_18 = { class: "tab-count" }
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = { class: "item-checkbox" }
const _hoisted_21 = { class: "item-main" }
const _hoisted_22 = { class: "item-top" }
const _hoisted_23 = { class: "item-date" }
const _hoisted_24 = {
  key: 0,
  class: "date-diff-tag"
}
const _hoisted_25 = { class: "item-price" }
const _hoisted_26 = { class: "item-memo" }
const _hoisted_27 = { class: "item-status" }
const _hoisted_28 = {
  key: 0,
  class: "loading-cashbook"
}
const _hoisted_29 = {
  key: 1,
  class: "empty-cashbook"
}
const _hoisted_30 = { class: "receipt-panel" }
const _hoisted_31 = { class: "panel-header centered" }
const _hoisted_32 = { class: "count" }
const _hoisted_33 = { class: "receipt-tabs" }
const _hoisted_34 = { class: "tab-count" }
const _hoisted_35 = { class: "tab-count" }
const _hoisted_36 = { class: "tab-count" }
const _hoisted_37 = {
  key: 0,
  class: "receipt-folder"
}
const _hoisted_38 = ["title", "onClick"]
const _hoisted_39 = { class: "item-content" }
const _hoisted_40 = { class: "item-thumb" }
const _hoisted_41 = ["src", "alt"]
const _hoisted_42 = {
  key: 0,
  class: "canvas-index-badge"
}
const _hoisted_43 = {
  key: 1,
  class: "thumb-overlay added"
}
const _hoisted_44 = {
  key: 2,
  class: "thumb-overlay loading"
}
const _hoisted_45 = { class: "item-info" }
const _hoisted_46 = { class: "item-date" }
const _hoisted_47 = {
  key: 0,
  class: "date-diff-tag"
}
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "item-badges" }
const _hoisted_50 = { class: "merged-badge" }
const _hoisted_51 = {
  key: 0,
  class: "match-badge"
}
const _hoisted_52 = { class: "merged-actions" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick", "title"]
const _hoisted_55 = { class: "expand-label" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "child-receipts"
}
const _hoisted_58 = ["title"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "item-thumb" }
const _hoisted_61 = ["src", "alt"]
const _hoisted_62 = {
  key: 0,
  class: "thumb-overlay added"
}
const _hoisted_63 = { class: "item-info" }
const _hoisted_64 = ["title"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["title", "onClick"]
const _hoisted_67 = { class: "item-content" }
const _hoisted_68 = { class: "item-thumb" }
const _hoisted_69 = ["src", "alt"]
const _hoisted_70 = {
  key: 0,
  class: "canvas-index-badge"
}
const _hoisted_71 = {
  key: 1,
  class: "thumb-overlay added"
}
const _hoisted_72 = {
  key: 2,
  class: "thumb-overlay loading"
}
const _hoisted_73 = { class: "item-info" }
const _hoisted_74 = { class: "item-date" }
const _hoisted_75 = {
  key: 0,
  class: "date-diff-tag"
}
const _hoisted_76 = ["title"]
const _hoisted_77 = {
  key: 0,
  class: "item-match-count"
}
const _hoisted_78 = { class: "item-actions" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  key: 0,
  class: "empty-receipts"
}
const _hoisted_82 = {
  key: 1,
  class: "loading-receipts"
}
const _hoisted_83 = { class: "center-panel canvas-mode" }
const _hoisted_84 = {
  key: 0,
  class: "canvas-toolbar"
}
const _hoisted_85 = { class: "toolbar-pages" }
const _hoisted_86 = ["onClick", "title"]
const _hoisted_87 = { class: "page-num" }
const _hoisted_88 = {
  key: 0,
  class: "page-count"
}
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "toolbar-info" }
const _hoisted_91 = { class: "info-badge" }
const _hoisted_92 = {
  key: 0,
  class: "date-diff-hint"
}
const _hoisted_93 = { class: "info-badge" }
const _hoisted_94 = { class: "toolbar-actions" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = ["disabled"]
const _hoisted_97 = ["disabled"]
const _hoisted_98 = {
  key: 1,
  class: "canvas-area"
}
const _hoisted_99 = {
  key: 0,
  class: "a4-paper"
}
const _hoisted_100 = {
  key: 1,
  class: "empty-canvas"
}
const _hoisted_101 = {
  key: 2,
  class: "existing-match-viewer"
}
const _hoisted_102 = { class: "match-toolbar" }
const _hoisted_103 = { class: "match-info" }
const _hoisted_104 = { class: "match-actions" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = {
  key: 0,
  class: "matched-images-tabs"
}
const _hoisted_107 = {
  key: 1,
  class: "single-type-label"
}
const _hoisted_108 = {
  key: 2,
  class: "single-type-label"
}
const _hoisted_109 = {
  key: 3,
  class: "matched-images-grid"
}
const _hoisted_110 = ["onClick"]
const _hoisted_111 = ["src", "alt"]
const _hoisted_112 = {
  key: 0,
  class: "item-overlay"
}
const _hoisted_113 = {
  key: 4,
  class: "matched-images-grid"
}
const _hoisted_114 = ["onClick"]
const _hoisted_115 = ["src", "alt"]
const _hoisted_116 = {
  key: 0,
  class: "item-overlay"
}
const _hoisted_117 = {
  key: 5,
  class: "matched-preview"
}
const _hoisted_118 = ["src"]
const _hoisted_119 = {
  key: 3,
  class: "loading-area"
}
const _hoisted_120 = { class: "merged-delete-dialog__title-text" }
const _hoisted_121 = ["disabled"]
const _hoisted_122 = {
  key: 0,
  class: "mt-3 pa-2 bg-grey-lighten-4 rounded"
}
const _hoisted_123 = { class: "text-body-2" }
const _hoisted_124 = { class: "text-caption text-grey" }
const _hoisted_125 = ["disabled"]
const _hoisted_126 = { class: "preview-title" }
const _hoisted_127 = {
  key: 0,
  class: "preview-date"
}
const _hoisted_128 = { class: "preview-index" }
const _hoisted_129 = { class: "zoom-controls" }
const _hoisted_130 = { class: "zoom-level" }
const _hoisted_131 = ["src", "alt"]
const _hoisted_132 = {
  key: 0,
  class: "already-in-canvas"
}
const _hoisted_133 = { class: "receipt-crop-modal" }
const _hoisted_134 = { class: "rcm-header" }
const _hoisted_135 = { class: "rcm-title" }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { class: "rcm-actions" }
const _hoisted_138 = ["disabled"]
const _hoisted_139 = ["disabled"]
const _hoisted_140 = ["disabled"]
const _hoisted_141 = ["disabled"]
const _hoisted_142 = { class: "rcm-body" }
const _hoisted_143 = { class: "rcm-stage" }
const _hoisted_144 = ["src", "alt"]
const _hoisted_145 = {
  key: 0,
  class: "rcm-strip"
}
const _hoisted_146 = ["onClick"]
const _hoisted_147 = ["src", "alt"]

import { ref, computed, watch, nextTick, onBeforeUnmount } from 'vue'
import api from '@/services/api'
// @ts-ignore
import { fabric } from 'fabric'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import ReceiptEditModal from './ReceiptEditModal.vue'

// 인터페이스 정의
interface CashbookItem {
  cb_idx?: number
  m_code?: number
  cb_date: string
  cb_gubun: string
  cb_price: number
  cb_memo: string
  cb_briefs?: string  // 적요
  cb_scode?: string
  cb_rel_acc?: string
  cb_receipt_matched?: number
  crm_code?: number
}

interface Receipt {
  idx: number
  fileName: string
  fileUrl?: string
  mCode?: string
  scanDate?: string
  description?: string
  matched?: number
  matchCount?: number  // 활성화된 매칭 건수
  crmIdx?: number  // 매칭된 경우 crm_code (같은 값이면 같은 그룹)
  matchedCbIdx?: number  // 매칭된 통장내역 cb_idx
  isDateMatch?: boolean
  isMerged?: boolean
  isCurrentMatched?: boolean  // 현재 선택된 통장내역에 매칭된 영수증인지
}

interface CanvasPage {
  id: string
  canvas: fabric.Canvas | null
  receipts: string[]  // 파일명 목록
}

interface AccountCode {
  scode: string
  sname: string
  gubun: string
}

// Props
const CANVAS_WIDTH = 595
const CANVAS_HEIGHT = 842

// Computed

export default /*@__PURE__*/_defineComponent({
  __name: 'ReceiptMatchingDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    cashbookItem: {},
    mCode: {},
    bizGubun: {},
    accountCodes: {},
    currentYear: {},
    currentMonth: {},
    embedded: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Emits
const emit = __emit

const dialogOpen = ref(props.modelValue)

const dialogVisible = computed({
  get: () => props.embedded ? true : dialogOpen.value,
  set: (value) => {
    if (props.embedded) return
    dialogOpen.value = value
    emit('update:modelValue', value)
  }
})

const wrapperBind = computed(() => {
  if (props.embedded) {
    return { class: 'receipt-matching-embed-host' }
  }
  return {
    modelValue: dialogVisible.value,
    fullscreen: true,
    persistent: true,
    class: 'receipt-matching-dialog fullscreen',
  }
})

const onWrapperModelUpdate = (value: boolean) => {
  dialogVisible.value = value
}

const isActive = computed(() => props.embedded || dialogVisible.value)

const modalRef = ref<HTMLElement | null>(null)
const loadingReceipts = ref(false)
const loadingReceiptFile = ref<string | null>(null)  // 클릭 중인 영수증 파일명
const saving = ref(false)
const receiptList = ref<Receipt[]>([])
const filterDate = ref('')
const thumbnailTrack = ref<HTMLElement | null>(null)

// 영수증 필터 상태
const dateFilterType = ref<'day' | 'month'>('day')  // 일별(디폴트) / 월별
const receiptYearMonth = ref('')  // 영수증 연월 필터 (YYYY-MM)

// 통장내역 목록 관련 상태
const cashbookListForMatching = ref<CashbookItem[]>([])
const selectedCashbookItems = ref<CashbookItem[]>([])
// cashbookFilterGubun 제거됨 - 영수증 매칭은 지출(OUT)만 해당
const cashbookFilterMatched = ref('') // '' = 전체 (기본). 미매칭만 보면 이미 맞춘 건이 안 보여 헷갈림
const loadingCashbook = ref(false)

// 영수증 필터 상태
const receiptFilterMatched = ref('')  // '' = 전체, 'unmatched' = 미매칭, 'matched' = 매칭완료

const isCashbookReceiptMatched = (item: { cb_receipt_matched?: number | string | null } | null | undefined) =>
  Number(item?.cb_receipt_matched) === 1

const isReceiptMatchedFlag = (receipt: { matched?: number | string | null } | null | undefined) =>
  Number(receipt?.matched) === 1

// 날짜 필터 상태 (영수증 우선 선택 방식)
const selectedReceiptDate = ref<string | null>(null)

// 다중 페이지 캔버스 상태
const canvasPages = ref<CanvasPage[]>([])
const currentPageIndex = ref(0)
const fabricCanvasRef = ref<HTMLCanvasElement | null>(null)
const canvasWrapperRef = ref<HTMLElement | null>(null)

// 매칭 정보 (이미 매칭된 경우)
const existingMatching = ref<any>(null)
const matchedImages = ref<Receipt[]>([])

// 합성 영수증 이름 입력 다이얼로그
const mergedNameDialog = ref(false)
const mergedReceiptName = ref('')
const previewImageIndex = ref(0)

// 스낵바
const snackbar = ref(false)
const snackbarMessage = ref('')
const snackbarColor = ref('error')

// 영수증 이미지 미리보기
const receiptPreviewDialog = ref(false)
const receiptPreviewUrl = ref('')
const receiptPreviewName = ref('')
const previewZoom = ref(0.75)  // 기본 75%
const previewContainerRef = ref<HTMLElement | null>(null)
const previewCurrentReceipt = ref<Receipt | null>(null)  // 현재 미리보기 영수증
const previewReceiptIndex = ref(0)  // 현재 인덱스
const previewImageType = ref<'merged' | 'source'>('merged')
const matchedImageTab = ref<'merged' | 'source'>('merged')

// 영수증 수정 모달
const receiptEditModalVisible = ref(false)
const editingReceipt = ref<Receipt | null>(null)

// 합성 이미지와 원본 이미지 분리
const mergedMatchedImages = computed(() => {
  return matchedImages.value.filter(img => isMergedReceipt(img))
})

const sourceMatchedImages = computed(() => {
  return matchedImages.value.filter(img => !isMergedReceipt(img))
})

// 현재 미리보기 이미지
const currentPreviewImage = computed(() => {
  if (previewImageType.value === 'merged') {
    return mergedMatchedImages.value[previewImageIndex.value] || null
  } else {
    return sourceMatchedImages.value[previewImageIndex.value] || null
  }
})

// 미리보기 이미지 선택
const selectPreviewImage = (type: 'merged' | 'source', idx: number) => {
  previewImageType.value = type
  previewImageIndex.value = idx
}

// A4 캔버스 크기 (72dpi 기준)
const isAlreadyMatched = computed(() => {
  if (selectedCashbookItems.value.length === 0) return false
  // 선택 전부가 매칭된 상태(기존 매칭 보기)일 때만 뷰어 모드
  return selectedCashbookItems.value.every(item => isCashbookReceiptMatched(item))
})

const selectedTotal = computed(() => {
  return selectedCashbookItems.value.reduce((sum, item) => sum + (Number(item.cb_price) || 0), 0)
})

const selectedCashbookDate = computed(() => {
  return selectedCashbookItems.value[0]?.cb_date || null
})

const isCashbookItemSelected = (item: CashbookItem): boolean => {
  return selectedCashbookItems.value.some(i => i.cb_idx === item.cb_idx)
}

const hasMatchedInSelection = computed(() => {
  return selectedCashbookItems.value.some(item => isCashbookReceiptMatched(item))
})

/** 이미 맞춘 항목을 보는 중이거나, 미매칭/매칭이 섞이면 선택 불가. 날짜는 달라도 선택 가능 */
const isCashbookDateBlocked = (item: CashbookItem): boolean => {
  if (isCashbookItemSelected(item)) return false
  if (selectedCashbookItems.value.length === 0) return false
  if (isAlreadyMatched.value) return true
  if (!isCashbookReceiptMatched(selectedCashbookItems.value[0]) && isCashbookReceiptMatched(item)) {
    return true
  }
  return false
}

const cashbookSelectHint = (item: CashbookItem): string => {
  if (isCashbookItemSelected(item)) return '클릭하여 선택 해제'
  if (selectedCashbookItems.value.length === 0) return '클릭하여 선택'
  if (isAlreadyMatched.value) return '맞춘 항목 보기 중입니다. 선택을 해제한 뒤 다시 고르세요'
  if (!isCashbookReceiptMatched(selectedCashbookItems.value[0]) && isCashbookReceiptMatched(item)) {
    return '미매칭 선택 중에는 맞춘 항목을 같이 고를 수 없습니다'
  }
  const focusDate = selectedFilterDate.value
  if (focusDate && item.cb_date && item.cb_date.slice(0, 10) !== focusDate.slice(0, 10)) {
    return '날짜가 다릅니다. 선택하면 매칭할 수 있습니다'
  }
  return '클릭하여 추가 선택'
}

const matchedCashbookCount = computed(() => {
  return cashbookListForMatching.value.filter(item => isCashbookReceiptMatched(item)).length
})

const unmatchedCashbookCount = computed(() => {
  return cashbookListForMatching.value.filter(item => !isCashbookReceiptMatched(item)).length
})

// 현재 연월에 해당하는 영수증 목록 (카운트 기준)
const currentMonthReceipts = computed(() => {
  const year = props.currentYear
  const month = props.currentMonth
  if (!year || !month) return receiptList.value
  
  const filterYearMonth = `${year}-${month.padStart(2, '0')}`
  return receiptList.value.filter(receipt => {
    const scanYearMonth = receipt.scanDate?.substring(0, 7) || ''
    return scanYearMonth === filterYearMonth
  })
})

// 영수증 카운트 (탭용 - 현재 연월 기준)
const matchedReceiptCount = computed(() => {
  return currentMonthReceipts.value.filter(r => isReceiptMatchedFlag(r)).length
})

const unmatchedReceiptCount = computed(() => {
  return currentMonthReceipts.value.filter(r => !isReceiptMatchedFlag(r)).length
})

const filteredCashbookListForMatching = computed(() => {
  let list = [...cashbookListForMatching.value]
  // 이미 지출(OUT)만 로드되어 있으므로 구분 필터 불필요
  if (cashbookFilterMatched.value === 'matched') {
    list = list.filter(item => isCashbookReceiptMatched(item))
  } else if (cashbookFilterMatched.value === 'unmatched') {
    list = list.filter(item => !isCashbookReceiptMatched(item))
  }

  // 영수증/통장 기준 날짜가 있으면 같은 날짜를 위로
  const focusDate = selectedFilterDate.value
  if (focusDate) {
    list.sort((a, b) => {
      const aMatch = a.cb_date === focusDate
      const bMatch = b.cb_date === focusDate
      if (aMatch && !bMatch) return -1
      if (!aMatch && bMatch) return 1
      if (a.cb_date !== b.cb_date) return (a.cb_date || '').localeCompare(b.cb_date || '')
      return (Number(b.cb_price) || 0) - (Number(a.cb_price) || 0)
    })
  }
  return list
})

// 현재 선택된 날짜 (영수증 또는 통장내역 클릭 시 설정)
const selectedFilterDate = computed(() => {
  // 1. 캔버스에 영수증이 있으면 그 날짜
  const firstPage = canvasPages.value[0]
  if (firstPage && firstPage.receipts.length > 0) {
    const firstFileName = firstPage.receipts[0]
    const receipt = receiptList.value.find(r => r.fileName === firstFileName)
    if (receipt?.scanDate) {
      return receipt.scanDate.split(' ')[0]
    }
  }
  
  // 2. 통장내역이 선택되어 있으면 그 날짜
  if (selectedCashbookItems.value.length > 0) {
    return selectedCashbookItems.value[0]?.cb_date || null
  }
  
  // 3. 둘 다 없으면 null (전체 표시)
  return null
})

// 통장내역 목록 (탭 필터만 — 선택해도 목록은 그대로)
const filteredCashbookByDate = computed(() => filteredCashbookListForMatching.value)

// 합성 영수증인지 확인 (receiptsByDate에서 사용하므로 먼저 정의)
const isMergedReceipt = (receipt: Receipt): boolean => {
  const fileName = receipt.fileName || ''
  return fileName.startsWith('merged/') || fileName.endsWith('_merged.png')
}

// 해당 영수증이 합성 영수증의 하위(원본)인지
const isChildOfMerged = (receipt: Receipt): boolean => {
  if (isMergedReceipt(receipt)) return false

  // 1) 같은 crmIdx의 합성 영수증이 목록에 있으면 하위
  if (receipt.crmIdx) {
    const hasMergedSibling = receiptList.value.some(
      (r) => isMergedReceipt(r) && Number(r.crmIdx) === Number(receipt.crmIdx)
    )
    if (hasMergedSibling) return true
  }

  // 2) 현재 매칭의 source_images에 포함된 원본이면 하위
  const hasMergedInMatch = matchedImages.value.some((m) => isMergedReceipt(m))
  if (
    hasMergedInMatch &&
    matchedImages.value.some((m) => !isMergedReceipt(m) && m.fileName === receipt.fileName)
  ) {
    return true
  }

  return false
}

const isReceiptSameDateAsSelected = (receipt: Receipt): boolean => {
  const focusDate = selectedFilterDate.value
  if (!focusDate) return false
  const scanDate = receipt.scanDate?.split(' ')[0] || ''
  return scanDate === focusDate
}

const isCashbookDateDifferent = (item: CashbookItem): boolean => {
  const focusDate = selectedFilterDate.value
  if (!focusDate || !item.cb_date) return false
  return item.cb_date.slice(0, 10) !== focusDate.slice(0, 10)
}

/** 선택된 통장 날짜와 캔버스 영수증 날짜 */
const selectedMatchDates = () => {
  const bankDates = [...new Set(
    selectedCashbookItems.value
      .map((item) => String(item.cb_date || '').slice(0, 10))
      .filter(Boolean)
  )]
  const receiptDates = new Set<string>()
  for (const page of canvasPages.value) {
    for (const fileName of page.receipts) {
      const receipt = receiptList.value.find((row) => row.fileName === fileName)
      const scanDate = receipt?.scanDate?.split(' ')[0] || ''
      if (scanDate) receiptDates.add(scanDate)
    }
  }
  return { bankDates, receiptDates: [...receiptDates] }
}

const crossDateHint = computed(() => {
  const { bankDates, receiptDates } = selectedMatchDates()
  if (!bankDates.length || !receiptDates.length) return ''
  const all = new Set([...bankDates, ...receiptDates])
  if (all.size <= 1) return ''
  return '날짜가 다릅니다. 매칭 시 한 번 확인합니다'
})

// 영수증 필터링 및 정렬 (월 전체 유지 · 통장 선택 시 같은 날짜를 위로)
const filteredAndSortedReceipts = computed(() => {
  const year = props.currentYear
  const month = props.currentMonth
  
  let list = [...receiptList.value]
  
  // 영수증 탭 필터 적용 (미매칭/매칭완료/전체)
  if (receiptFilterMatched.value === 'matched') {
    list = list.filter(receipt => isReceiptMatchedFlag(receipt))
  } else if (receiptFilterMatched.value === 'unmatched') {
    list = list.filter(receipt => !isReceiptMatchedFlag(receipt))
  }
  
  // 해당 연월 전체 (통장 선택해도 날짜로 잘라내지 않음)
  if (year && month) {
    const filterYearMonth = `${year}-${String(month).padStart(2, '0')}`
    list = list.filter(receipt => {
      const scanYearMonth = receipt.scanDate?.substring(0, 7) || ''
      return scanYearMonth === filterYearMonth
    })
  }

  // 합성 묶음의 원본은 목록에서 숨김 → 묶음 펼침 시에만 표시
  list = list.filter((receipt) => isMergedReceipt(receipt) || !isChildOfMerged(receipt))

  const focusDate = selectedFilterDate.value
  
  list.sort((a, b) => {
    // 1) 현재 매칭된 영수증
    if (a.isCurrentMatched && !b.isCurrentMatched) return -1
    if (!a.isCurrentMatched && b.isCurrentMatched) return 1

    // 2) 합성 묶음 우선
    const aMerged = isMergedReceipt(a)
    const bMerged = isMergedReceipt(b)
    if (aMerged && !bMerged) return -1
    if (!aMerged && bMerged) return 1

    // 3) 기준 날짜(통장/영수증)와 같은 날짜 우선
    if (focusDate) {
      const aMatch = (a.scanDate?.split(' ')[0] || '') === focusDate
      const bMatch = (b.scanDate?.split(' ')[0] || '') === focusDate
      if (aMatch && !bMatch) return -1
      if (!aMatch && bMatch) return 1
    }

    // 4) 날짜순
    const dateA = a.scanDate?.split(' ')[0] || ''
    const dateB = b.scanDate?.split(' ')[0] || ''
    if (dateA !== dateB) return dateA.localeCompare(dateB)

    return a.fileName.localeCompare(b.fileName)
  })
  
  return list
})

// 영수증을 날짜별로 그룹핑 (전체 영수증 표시)
const receiptsByDate = computed(() => {
  const groups = new Map<string, Receipt[]>()
  
  // 모든 영수증을 날짜별로 그룹화
  receiptList.value.forEach(receipt => {
    const date = receipt.scanDate?.split(' ')[0] || 'unknown'
    if (!groups.has(date)) groups.set(date, [])
    groups.get(date)!.push(receipt)
  })
  
  // 날짜순 정렬 (최신 날짜부터)
  return Array.from(groups.entries()).sort((a, b) => b[0].localeCompare(a[0]))
})

// 날짜별 매칭된 영수증 개수
const getMatchedCountByDate = (date: string): number => {
  return receiptList.value.filter(r => {
    const rDate = r.scanDate?.split(' ')[0] || ''
    return rDate === date && r.matched === 1
  }).length
}

// 날짜 필터 토글
const toggleDateFilter = (date: string) => {
  if (selectedReceiptDate.value === date) {
    // 같은 날짜 클릭 시 필터 해제
    selectedReceiptDate.value = null
  } else {
    // 다른 날짜 클릭 시 해당 날짜로 필터
    selectedReceiptDate.value = date
    filterDate.value = date
  }
}

// 날짜 필터 해제
const clearReceiptDateFilter = () => {
  selectedReceiptDate.value = null
  filterDate.value = ''
}

// 날짜 그룹 포맷 (예: "4월 3일")
const formatGroupDate = (date: string): string => {
  if (!date || date === 'unknown') return '날짜 없음'
  try {
    const d = new Date(date)
    if (isNaN(d.getTime())) return date
    return `${d.getMonth() + 1}월 ${d.getDate()}일`
  } catch {
    return date
  }
}

// 영수증 날짜 포맷 (예: "5/3")
const formatReceiptDate = (scanDate: string | null | undefined): string => {
  if (!scanDate) return '-'
  try {
    const dateStr = scanDate.split(' ')[0]
    const d = new Date(dateStr)
    if (isNaN(d.getTime())) return '-'
    return `${d.getMonth() + 1}/${d.getDate()}`
  } catch {
    return '-'
  }
}

// 목록용 적요 (시드 접두어 제거 · 본문 강조)
const formatReceiptMemo = (description: string | null | undefined): string => {
  const raw = String(description || '').trim()
  if (!raw) return '-'
  return raw.replace(/^\[함우리시드\]\s*/, '')
}

// 전체 캔버스에 있는 영수증 총 개수
const totalReceiptsInCanvas = computed(() => {
  return canvasPages.value.reduce((sum, page) => sum + page.receipts.length, 0)
})

// 현재 페이지
const currentPage = computed(() => {
  return canvasPages.value[currentPageIndex.value] || null
})

// 캔버스에서 선택된 객체가 있는지 확인
const hasSelectedObject = ref(false)

// 영수증이 어떤 캔버스에든 있는지 확인
const isReceiptInAnyCanvas = (receipt: Receipt): boolean => {
  return canvasPages.value.some(page => page.receipts.includes(receipt.fileName))
}

// 영수증의 캔버스 내 순번 가져오기
const getReceiptCanvasIndex = (receipt: Receipt): number | null => {
  for (const page of canvasPages.value) {
    if (page.canvas && page.receipts.includes(receipt.fileName)) {
      const obj = page.canvas.getObjects().find((o: any) => o.fileName === receipt.fileName)
      if (obj) {
        // @ts-ignore
        return obj.canvasIndex || null
      }
    }
  }
  return null
}

// 펼쳐진 합성 영수증 목록
const expandedMergedReceipts = ref<Set<string>>(new Set())

// 합성 영수증 펼침/접기 토글
const toggleMergedExpand = (receipt: Receipt) => {
  if (expandedMergedReceipts.value.has(receipt.fileName)) {
    expandedMergedReceipts.value.delete(receipt.fileName)
  } else {
    expandedMergedReceipts.value.add(receipt.fileName)
  }
  // Set의 변경을 Vue가 감지하도록 새 Set 생성
  expandedMergedReceipts.value = new Set(expandedMergedReceipts.value)
}

// 합성 영수증의 하위 영수증 가져오기
const getChildReceipts = (mergedReceipt: Receipt): Receipt[] => {
  const fromList = receiptList.value.filter((r) => {
    if (isMergedReceipt(r)) return false
    if (mergedReceipt.crmIdx && Number(r.crmIdx) === Number(mergedReceipt.crmIdx)) return true
    return false
  })

  // 목록에 없으면 현재 매칭의 source_images에서 보강
  const fromMatched = matchedImages.value.filter((r) => {
    if (isMergedReceipt(r)) return false
    if (fromList.some((x) => x.fileName === r.fileName)) return false
    if (mergedReceipt.crmIdx && Number(r.crmIdx) === Number(mergedReceipt.crmIdx)) return true
    // 같은 매칭 그룹의 원본
    return matchedImages.value.some((m) => isMergedReceipt(m) && m.fileName === mergedReceipt.fileName)
      && !isMergedReceipt(r)
  })

  return [...fromList, ...fromMatched]
}

// 그룹화된 영수증 목록 (합성 영수증과 독립 일반 영수증만)
const groupedReceiptList = computed(() => {
  return filteredReceiptList.value.filter(receipt => {
    // 합성 영수증은 포함
    if (isMergedReceipt(receipt)) return true
    // 합성의 하위가 아닌 일반 영수증만 포함
    return !isChildOfMerged(receipt)
  })
})

// 합성 영수증 삭제 관련
const deleteMergedDialog = ref(false)
const receiptToDelete = ref<Receipt | null>(null)
const deletingMerged = ref(false)

// 합성 영수증 삭제 확인 다이얼로그 열기
const confirmDeleteMergedReceipt = (receipt: Receipt) => {
  receiptToDelete.value = receipt
  deleteMergedDialog.value = true
}

// 합성 영수증 삭제 실행
const deleteMergedReceipt = async () => {
  if (!receiptToDelete.value || !props.mCode) return
  
  deletingMerged.value = true
  try {
    // 합성 영수증 파일명: merged/xxx.png → /scan/:mCode/merged/:fileName
    const fileName = receiptToDelete.value.fileName
    const apiPath = fileName.startsWith('merged/') 
      ? `/scan/${props.mCode}/merged/${fileName.replace('merged/', '')}`
      : `/scan/${props.mCode}/${fileName}`
    
    const response = await api.delete(apiPath)
    
    if (response.data.success) {
      const deletedReceipt = receiptToDelete.value!
      
      // 매칭된 영수증이었다면 매칭 해제
      if (deletedReceipt.matched === 1 && deletedReceipt.crmIdx) {
        try {
          // 매칭 해제 API 호출
          await api.delete(`/receipt-matching/${deletedReceipt.crmIdx}`)
          
          // 관련 통장내역 아이템의 매칭 상태 업데이트
          if (deletedReceipt.matchedCbIdx) {
            const cbItem = cashbookListForMatching.value.find(
              cb => cb.cb_idx === deletedReceipt.matchedCbIdx
            )
            if (cbItem) {
              cbItem.cb_receipt_matched = 0
            }
          }
          
          // 기존 매칭 정보 초기화
          existingMatching.value = null
          matchedImages.value = []
        } catch (matchError) {
          console.error('매칭 해제 오류:', matchError)
        }
      }
      
      // 목록에서 제거
      receiptList.value = receiptList.value.filter(r => r.fileName !== deletedReceipt.fileName)
      
      // 캔버스 비우기
      disposeAllCanvases()
      canvasPages.value = []
      currentPageIndex.value = 0
      
      // 선택된 통장내역 초기화
      selectedCashbookItems.value = []
      
      deleteMergedDialog.value = false
      receiptToDelete.value = null
      
      // 통장내역 목록 새로고침
      await loadCashbookList()
    } else {
      console.error('합성 영수증 삭제 실패:', response.data.message)
      alert('삭제에 실패했습니다: ' + (response.data.message || '알 수 없는 오류'))
    }
  } catch (error) {
    console.error('합성 영수증 삭제 오류:', error)
    alert('삭제 중 오류가 발생했습니다.')
  } finally {
    deletingMerged.value = false
  }
}

// 필터링된 영수증 목록 (통장내역 탭과 연동)
const filteredReceiptList = computed(() => {
  let list = [...receiptList.value]
  
  // 날짜 필터 (일별/월별)
  if (dateFilterType.value === 'day' && filterDate.value) {
    // 일별: 해당 날짜 영수증만
    list = list.filter(receipt => {
      // 현재 선택된 통장내역에 매칭된 영수증은 항상 표시
      if (receipt.isCurrentMatched) return true
      const scanDate = receipt.scanDate?.split(' ')[0] || ''
      return scanDate === filterDate.value
    })
  } else if (dateFilterType.value === 'month' && receiptYearMonth.value) {
    // 월별: 해당 연월 영수증만
    list = list.filter(receipt => {
      // 현재 선택된 통장내역에 매칭된 영수증은 항상 표시
      if (receipt.isCurrentMatched) return true
      const scanYearMonth = receipt.scanDate?.substring(0, 7) || ''
      return scanYearMonth === receiptYearMonth.value
    })
  }
  
  // 매칭 상태 필터: 통장내역 탭(cashbookFilterMatched)과 연동
  // - 미매칭 통장내역 선택 시 → 미매칭 영수증만 표시 (매칭 가능한 영수증)
  // - 매칭된 통장내역 선택 시 → 현재 매칭된 영수증 + 전체 영수증 표시
  if (isAlreadyMatched.value) {
    // 매칭된 통장내역: 현재 매칭된 영수증이 상단에 오도록 정렬 (필터 안 함)
  } else {
    // 미매칭 통장내역: 미매칭 영수증만 표시
    list = list.filter(receipt => !isReceiptMatchedFlag(receipt))
  }
  
  // 정렬: 현재 매칭된 > 날짜 일치 > 날짜순(1일~말일)
  list.sort((a, b) => {
    // 1순위: 현재 매칭된 영수증
    if (a.isCurrentMatched && !b.isCurrentMatched) return -1
    if (!a.isCurrentMatched && b.isCurrentMatched) return 1
    
    // 2순위: 날짜 일치
    if (a.isDateMatch && !b.isDateMatch) return -1
    if (!a.isDateMatch && b.isDateMatch) return 1
    
    // 3순위: 날짜순 오름차순 (1일 ~ 말일)
    const dateA = a.scanDate || ''
    const dateB = b.scanDate || ''
    if (dateA !== dateB) return dateA.localeCompare(dateB)
    
    // 4순위: 파일명순
    return a.fileName.localeCompare(b.fileName)
  })
  
  return list
})

// 날짜 필터 타입 변경
const setDateFilterType = (type: 'day' | 'month') => {
  dateFilterType.value = type
}

// 연월 변경 시 영수증 다시 로드
const onYearMonthChange = () => {
  loadUnmatchedReceipts()
}

// 필터 날짜 포맷
const formatFilterDate = (date: string): string => {
  if (!date) return ''
  const d = new Date(date)
  return `${d.getMonth() + 1}월 ${d.getDate()}일`
}

// 활성(모달 열림 / 탭 임베드) 시 초기화
const bootstrapMatching = async () => {
  resetState()

  if (props.currentYear && props.currentMonth) {
    receiptYearMonth.value = `${props.currentYear}-${String(props.currentMonth).padStart(2, '0')}`
  } else if (props.cashbookItem?.cb_date) {
    receiptYearMonth.value = props.cashbookItem.cb_date.substring(0, 7)
  } else {
    const now = new Date()
    receiptYearMonth.value = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
  }

  await Promise.all([
    loadUnmatchedReceipts(),
    loadCashbookList()
  ])

  await applyCashbookItemSelection()

  await initFirstPage()

  nextTick(() => {
    modalRef.value?.focus()
  })
}

const applyCashbookItemSelection = async () => {
  if (!props.cashbookItem) return

  const targetItem = cashbookListForMatching.value.find(
    item => item.cb_idx === props.cashbookItem?.cb_idx
  )
  if (!targetItem) return

  selectedCashbookItems.value = [targetItem]
  filterDate.value = targetItem.cb_date || ''

  await loadExistingMatching()
  if (existingMatching.value || isCashbookReceiptMatched(targetItem)) {
    targetItem.cb_receipt_matched = 1
    skipFilterWatchReset.value = true
    cashbookFilterMatched.value = 'matched'
    receiptFilterMatched.value = 'matched'
    await nextTick()
    skipFilterWatchReset.value = false
    if (!existingMatching.value) await loadExistingMatching()
  } else {
    cashbookFilterMatched.value = 'unmatched'
    receiptFilterMatched.value = 'unmatched'
  }
}

// 통장내역 탭(미매칭/매칭완료) 변경 시 선택 초기화
watch(cashbookFilterMatched, () => {
  // 프로그래밍 방식으로 탭 전환 시 스킵
  if (skipFilterWatchReset.value) return
  
  // 선택된 항목 초기화
  selectedCashbookItems.value = []
  
  // 캔버스 초기화
  disposeAllCanvases()
  canvasPages.value = []
  currentPageIndex.value = 0
  
  // 매칭 정보 초기화
  existingMatching.value = null
  matchedImages.value = []
  previewImageIndex.value = 0
  previewImageType.value = 'merged'
  matchedImageTab.value = 'merged'
  
  // 날짜 필터 초기화
  filterDate.value = ''
  
  // isCurrentMatched 플래그 초기화
  receiptList.value = receiptList.value.map(r => ({
    ...r,
    isCurrentMatched: false
  }))
})

// 매칭 이미지 탭 변경 시 미리보기 인덱스 초기화
watch(matchedImageTab, (newTab) => {
  previewImageIndex.value = 0
  previewImageType.value = newTab
})

// 필터 변경 시 선택 초기화 스킵 플래그
const skipFilterWatchReset = ref(false)

// 상태 초기화
const resetState = () => {
  selectedCashbookItems.value = []
  canvasPages.value = []
  currentPageIndex.value = 0
  existingMatching.value = null
  matchedImages.value = []
  previewImageIndex.value = 0
  previewImageType.value = 'merged'
  matchedImageTab.value = 'merged'
  cashbookFilterMatched.value = ''
  receiptFilterMatched.value = ''
  filterDate.value = ''
  receiptList.value = []
  hasSelectedObject.value = false
  dateFilterType.value = 'day'
  receiptYearMonth.value = ''
  mergedReceiptName.value = ''
  selectedReceiptDate.value = null  // 날짜 필터 초기화
}

// 캔버스 초기화 중인지 플래그
let isInitializingCanvas = false

// 모든 캔버스 정리
const disposeAllCanvases = () => {
  canvasPages.value.forEach(page => {
    if (page.canvas) {
      page.canvas.dispose()
      page.canvas = null
    }
  })
  canvasPages.value = []
  isInitializingCanvas = false
}

// 첫 페이지 초기화
const initFirstPage = async () => {
  if (canvasPages.value.length === 0) {
    const newPage: CanvasPage = {
      id: `page_${Date.now()}`,
      canvas: null,
      receipts: []
    }
    canvasPages.value.push(newPage)
    currentPageIndex.value = 0
  }
  
  // DOM이 준비될 때까지 대기
  await nextTick()
  await nextTick()
  
  await initCurrentCanvas()
}

// 새 페이지 추가
const addNewPage = async () => {
  // 현재 캔버스 상태 저장
  saveCurrentCanvasState()
  
  // 현재 캔버스 정리
  const currentPageObj = currentPage.value
  if (currentPageObj?.canvas) {
    currentPageObj.canvas.dispose()
    currentPageObj.canvas = null
  }
  
  const newPage: CanvasPage = {
    id: `page_${Date.now()}`,
    canvas: null,
    receipts: []
  }
  canvasPages.value.push(newPage)
  currentPageIndex.value = canvasPages.value.length - 1
  
  await nextTick()
  await nextTick()
  await initCurrentCanvas()
}

// 페이지 삭제
const removePage = async (index: number) => {
  if (canvasPages.value.length <= 1) return
  
  const page = canvasPages.value[index]
  if (page.canvas) {
    page.canvas.dispose()
    page.canvas = null
  }
  canvasPages.value.splice(index, 1)
  
  if (currentPageIndex.value >= canvasPages.value.length) {
    currentPageIndex.value = canvasPages.value.length - 1
  }
  
  // 현재 페이지의 캔버스도 정리 후 재초기화
  const newCurrentPage = currentPage.value
  if (newCurrentPage?.canvas) {
    newCurrentPage.canvas.dispose()
    newCurrentPage.canvas = null
  }
  
  await nextTick()
  await nextTick()
  await initCurrentCanvas()
  
  // 저장된 영수증 복원
  await restoreCanvasState(currentPageIndex.value)
}

// 페이지 전환
const switchToPage = async (index: number) => {
  if (index === currentPageIndex.value) return
  
  // 현재 캔버스 상태 저장 및 정리
  saveCurrentCanvasState()
  const currentPageObj = currentPage.value
  if (currentPageObj?.canvas) {
    currentPageObj.canvas.dispose()
    currentPageObj.canvas = null
  }
  
  currentPageIndex.value = index
  
  await nextTick()
  await nextTick()
  await initCurrentCanvas()
  
  // 저장된 상태 복원
  await restoreCanvasState(index)
}

// 현재 캔버스 상태 저장
const saveCurrentCanvasState = () => {
  const page = currentPage.value
  if (page && page.canvas) {
    // 캔버스 객체들의 파일명 목록 업데이트
    page.receipts = page.canvas.getObjects().map((obj: any) => obj.fileName).filter(Boolean)
  }
}

// 캔버스 상태 복원
const restoreCanvasState = async (pageIndex: number) => {
  const page = canvasPages.value[pageIndex]
  if (!page || !page.canvas) return
  
  // 이미 객체가 있으면 복원하지 않음 (이미 로드됨)
  if (page.canvas.getObjects().length > 0) return
  
  // 저장된 영수증 목록으로 캔버스 복원
  const receiptsToRestore = [...page.receipts]
  for (const fileName of receiptsToRestore) {
    const receipt = receiptList.value.find(r => r.fileName === fileName)
    if (receipt) {
      await addReceiptToCurrentCanvas(receipt, false)
    }
  }
}

// 현재 캔버스 초기화
const initCurrentCanvas = async () => {
  // 중복 초기화 방지
  if (isInitializingCanvas) return
  isInitializingCanvas = true
  
  try {
    if (!fabricCanvasRef.value) {
      console.warn('fabricCanvasRef not ready')
      return
    }
    
    const page = currentPage.value
    if (!page) {
      console.warn('No current page')
      return
    }
    
    // 기존 캔버스가 있으면 정리
    if (page.canvas) {
      page.canvas.dispose()
      page.canvas = null
    }
    
    await nextTick()
    
    // 새 캔버스 생성
    page.canvas = new fabric.Canvas(fabricCanvasRef.value, {
      width: CANVAS_WIDTH,
      height: CANVAS_HEIGHT,
      backgroundColor: '#ffffff',
      selection: true,
      preserveObjectStacking: true,
      // 기본 커서 설정 비활성화 (커스텀 구현 사용)
      defaultCursor: 'default',
      hoverCursor: 'default',
      moveCursor: 'default',
      rotationCursor: 'default'
    })
    
    // 디버깅용: 전역 변수로 노출
    // @ts-ignore
    window.__fabricCanvas = page.canvas
    
    // 이벤트 리스너
    page.canvas.on('object:removed', () => {
      // 캔버스 재초기화(dispose) 중에는 영수증 목록을 비우지 않음
      if (isInitializingCanvas) return
      updatePageReceipts()
    })
    
    // 선택 이벤트 리스너
    page.canvas.on('selection:created', () => {
      hasSelectedObject.value = true
    })
    page.canvas.on('selection:updated', () => {
      hasSelectedObject.value = true
    })
    page.canvas.on('selection:cleared', () => {
      hasSelectedObject.value = false
    })
    
    // ===== 커스텀 크기 조절 구현 =====
    
    // after:render 이벤트 - 커스텀 핸들 그리기 (나중에 함수 정의 후 연결)
    let drawHandlesCallback: ((canvas: fabric.Canvas) => void) | null = null
    page.canvas.on('after:render', () => {
      if (drawHandlesCallback && page.canvas) {
        drawHandlesCallback(page.canvas)
      }
    })
    // 드래그 상태 변수
    let isResizing = false
    let resizeCorner: string | null = null
    let resizeStartX = 0
    let resizeStartY = 0
    let originalLeft = 0
    let originalTop = 0
    let originalWidth = 0
    let originalHeight = 0
    let originalScaleX = 1
    let originalScaleY = 1
    
    // 핸들 크기 및 오프셋 설정 (이미지 안쪽에 위치)
    const HANDLE_SIZE = 12  // 핸들 크기
    const HANDLE_OFFSET = 6  // 이미지 경계에서 안쪽으로 들어가는 거리
    
    // 이미지 안쪽 핸들 좌표 계산
    const getHandlePositions = (obj: fabric.Object): Record<string, { x: number; y: number }> | null => {
      if (!obj.aCoords) return null
      
      const coords = obj.aCoords
      const offset = HANDLE_OFFSET
      
      return {
        tl: { x: coords.tl.x + offset, y: coords.tl.y + offset },
        tr: { x: coords.tr.x - offset, y: coords.tr.y + offset },
        bl: { x: coords.bl.x + offset, y: coords.bl.y - offset },
        br: { x: coords.br.x - offset, y: coords.br.y - offset },
        mt: { x: (coords.tl.x + coords.tr.x) / 2, y: coords.tl.y + offset },
        mb: { x: (coords.bl.x + coords.br.x) / 2, y: coords.bl.y - offset },
        ml: { x: coords.tl.x + offset, y: (coords.tl.y + coords.bl.y) / 2 },
        mr: { x: coords.tr.x - offset, y: (coords.tr.y + coords.br.y) / 2 }
      }
    }
    
    // 코너 감지 함수 (이미지 안쪽 핸들 기준)
    const detectCorner = (obj: fabric.Object, pointer: { x: number; y: number }): string | null => {
      const handles = getHandlePositions(obj)
      if (!handles) return null
      
      const halfSize = HANDLE_SIZE / 2 + 4  // 약간의 여유 추가
      
      for (const [name, pos] of Object.entries(handles)) {
        if (pointer.x >= pos.x - halfSize && pointer.x <= pos.x + halfSize &&
            pointer.y >= pos.y - halfSize && pointer.y <= pos.y + halfSize) {
          return name
        }
      }
      
      return null
    }
    
    // 포인터가 객체 내부에 있는지 확인 (핸들 영역 제외)
    const isPointerInsideObject = (obj: fabric.Object, pointer: { x: number; y: number }): boolean => {
      if (!obj.aCoords) return false
      
      const coords = obj.aCoords
      const padding = HANDLE_SIZE + HANDLE_OFFSET  // 핸들 영역 제외
      
      const minX = Math.min(coords.tl.x, coords.bl.x) + padding
      const maxX = Math.max(coords.tr.x, coords.br.x) - padding
      const minY = Math.min(coords.tl.y, coords.tr.y) + padding
      const maxY = Math.max(coords.bl.y, coords.br.y) - padding
      
      return pointer.x >= minX && pointer.x <= maxX && pointer.y >= minY && pointer.y <= maxY
    }
    
    // 모든 이미지에 번호 배지 그리기
    const drawImageNumbers = (canvas: fabric.Canvas) => {
      const ctx = canvas.getContext()
      const objects = canvas.getObjects()
      
      ctx.save()
      
      objects.forEach((obj: any) => {
        if (!obj.aCoords || !obj.canvasIndex) return
        
        const coords = obj.aCoords
        const index = obj.canvasIndex
        
        // 좌상단에 번호 배지 그리기
        const badgeSize = 24
        const badgeX = coords.tl.x
        const badgeY = coords.tl.y
        
        // 배지 배경 (파란색 원)
        ctx.fillStyle = '#1e3a5f'
        ctx.beginPath()
        ctx.arc(badgeX + badgeSize / 2, badgeY + badgeSize / 2, badgeSize / 2, 0, Math.PI * 2)
        ctx.fill()
        
        // 배지 테두리 (흰색)
        ctx.strokeStyle = '#ffffff'
        ctx.lineWidth = 2
        ctx.stroke()
        
        // 번호 텍스트
        ctx.fillStyle = '#ffffff'
        ctx.font = 'bold 14px Arial'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText(String(index), badgeX + badgeSize / 2, badgeY + badgeSize / 2)
      })
      
      ctx.restore()
    }
    
    // 커스텀 핸들 그리기 (캔버스 after:render 이벤트에서 호출)
    const drawCustomHandles = (canvas: fabric.Canvas) => {
      const ctx = canvas.getContext()
      
      ctx.save()
      
      // 모든 이미지에 번호 표시
      drawImageNumbers(canvas)
      
      // 선택된 객체에만 핸들 그리기
      const activeObj = canvas.getActiveObject()
      if (activeObj) {
        const handles = getHandlePositions(activeObj)
        if (handles) {
          const size = HANDLE_SIZE
          const halfSize = size / 2
          
          // 테두리 그리기
          if (activeObj.aCoords) {
            const coords = activeObj.aCoords
            ctx.strokeStyle = '#1e3a5f'
            ctx.lineWidth = 2
            ctx.beginPath()
            ctx.moveTo(coords.tl.x, coords.tl.y)
            ctx.lineTo(coords.tr.x, coords.tr.y)
            ctx.lineTo(coords.br.x, coords.br.y)
            ctx.lineTo(coords.bl.x, coords.bl.y)
            ctx.closePath()
            ctx.stroke()
          }
          
          // 핸들 그리기
          for (const [, pos] of Object.entries(handles)) {
            // 핸들 배경 (흰색)
            ctx.fillStyle = '#ffffff'
            ctx.fillRect(pos.x - halfSize, pos.y - halfSize, size, size)
            
            // 핸들 테두리 (파란색)
            ctx.strokeStyle = '#1e3a5f'
            ctx.lineWidth = 2
            ctx.strokeRect(pos.x - halfSize, pos.y - halfSize, size, size)
          }
        }
      }
      
      ctx.restore()
    }
    
    // 콜백 연결
    drawHandlesCallback = drawCustomHandles
    
    // 커서 스타일 맵
    const cursorMap: Record<string, string> = {
      tl: 'nwse-resize', tr: 'nesw-resize', bl: 'nesw-resize', br: 'nwse-resize',
      ml: 'ew-resize', mr: 'ew-resize', mt: 'ns-resize', mb: 'ns-resize'
    }
    
    // mouse:move 이벤트
    page.canvas.on('mouse:move', (opt: any) => {
      const canvas = page.canvas!
      const pointer = canvas.getPointer(opt.e)
      
      // 리사이즈 중이면 크기 조절
      if (isResizing && resizeCorner) {
        const activeObj = canvas.getActiveObject()
        if (!activeObj) return
        
        const deltaX = pointer.x - resizeStartX
        const deltaY = pointer.y - resizeStartY
        
        let newLeft = originalLeft
        let newTop = originalTop
        let newScaleX = originalScaleX
        let newScaleY = originalScaleY
        
        switch (resizeCorner) {
          case 'br': // 오른쪽 아래
            newScaleX = originalScaleX + deltaX / originalWidth
            newScaleY = originalScaleY + deltaY / originalHeight
            break
          case 'bl': // 왼쪽 아래
            newScaleX = originalScaleX - deltaX / originalWidth
            newScaleY = originalScaleY + deltaY / originalHeight
            newLeft = originalLeft + deltaX
            break
          case 'tr': // 오른쪽 위
            newScaleX = originalScaleX + deltaX / originalWidth
            newScaleY = originalScaleY - deltaY / originalHeight
            newTop = originalTop + deltaY
            break
          case 'tl': // 왼쪽 위
            newScaleX = originalScaleX - deltaX / originalWidth
            newScaleY = originalScaleY - deltaY / originalHeight
            newLeft = originalLeft + deltaX
            newTop = originalTop + deltaY
            break
          case 'mr': // 오른쪽 중간
            newScaleX = originalScaleX + deltaX / originalWidth
            break
          case 'ml': // 왼쪽 중간
            newScaleX = originalScaleX - deltaX / originalWidth
            newLeft = originalLeft + deltaX
            break
          case 'mb': // 아래 중간
            newScaleY = originalScaleY + deltaY / originalHeight
            break
          case 'mt': // 위 중간
            newScaleY = originalScaleY - deltaY / originalHeight
            newTop = originalTop + deltaY
            break
        }
        
        // 최소 크기 제한
        const minScale = 0.1
        if (newScaleX >= minScale && newScaleY >= minScale) {
          // 캔버스 경계 체크
          const objWidth = originalWidth * newScaleX
          const objHeight = originalHeight * newScaleY
          
          // 경계 제한 적용
          if (newLeft < 0) newLeft = 0
          if (newTop < 0) newTop = 0
          if (newLeft + objWidth > CANVAS_WIDTH) {
            if (resizeCorner?.includes('l')) {
              // 왼쪽 핸들: left 조정 대신 스케일 제한
              newLeft = 0
              newScaleX = (originalLeft + originalWidth * originalScaleX) / originalWidth
            } else {
              // 오른쪽 핸들: 스케일 제한
              newScaleX = (CANVAS_WIDTH - newLeft) / originalWidth
            }
          }
          if (newTop + objHeight > CANVAS_HEIGHT) {
            if (resizeCorner?.includes('t')) {
              // 위쪽 핸들: top 조정 대신 스케일 제한
              newTop = 0
              newScaleY = (originalTop + originalHeight * originalScaleY) / originalHeight
            } else {
              // 아래쪽 핸들: 스케일 제한
              newScaleY = (CANVAS_HEIGHT - newTop) / originalHeight
            }
          }
          
          // 최종 경계 확인 후 적용
          if (newScaleX >= minScale && newScaleY >= minScale &&
              newLeft >= 0 && newTop >= 0 &&
              newLeft + originalWidth * newScaleX <= CANVAS_WIDTH &&
              newTop + originalHeight * newScaleY <= CANVAS_HEIGHT) {
            activeObj.set({
              left: newLeft,
              top: newTop,
              scaleX: newScaleX,
              scaleY: newScaleY
            })
            activeObj.setCoords()
            canvas.requestRenderAll()
          }
        }
        return
      }
      
      // 코너 위에 있으면 커서 변경
      const activeObj = canvas.getActiveObject()
      if (activeObj) {
        const corner = detectCorner(activeObj, pointer)
        if (corner) {
          canvas.upperCanvasEl.style.cursor = cursorMap[corner] || 'default'
        } else if (opt.target === activeObj) {
          // 실제 이미지 영역 내부인지 확인 (테두리 제외)
          const isInsideObject = isPointerInsideObject(activeObj, pointer)
          canvas.upperCanvasEl.style.cursor = isInsideObject ? 'move' : 'default'
        } else {
          canvas.upperCanvasEl.style.cursor = 'default'
        }
      } else {
        canvas.upperCanvasEl.style.cursor = 'default'
      }
    })
    
    // mouse:down 이벤트
    page.canvas.on('mouse:down', (opt: any) => {
      const canvas = page.canvas!
      const pointer = canvas.getPointer(opt.e)
      const target = opt.target
      
      // 이미 선택된 객체가 있으면 먼저 코너/내부 감지
      const activeObj = canvas.getActiveObject()
      if (activeObj) {
        const corner = detectCorner(activeObj, pointer)
        
        if (corner) {
          // 리사이즈 시작 - 선택 해제 방지
          opt.e.preventDefault()
          opt.e.stopPropagation()
          
          isResizing = true
          resizeCorner = corner
          resizeStartX = pointer.x
          resizeStartY = pointer.y
          originalLeft = activeObj.left || 0
          originalTop = activeObj.top || 0
          originalWidth = activeObj.width || 100
          originalHeight = activeObj.height || 100
          originalScaleX = activeObj.scaleX || 1
          originalScaleY = activeObj.scaleY || 1
          
          // 이동 잠금
          activeObj.lockMovementX = true
          activeObj.lockMovementY = true
          return  // 여기서 리턴하여 선택 해제 방지
        }
        
        // 테두리 영역 클릭 감지 (코너도 아니고 이미지 내부도 아닌 곳)
        // target이 activeObj인데 내부가 아니면 테두리 클릭 → 선택 유지
        if (target === activeObj && !isPointerInsideObject(activeObj, pointer)) {
          // 테두리 클릭 - 아무것도 하지 않음 (선택 유지)
          opt.e.preventDefault()
          opt.e.stopPropagation()
          return
        }
      }
      
      // 타겟이 없으면 (빈 공간 클릭) 선택 해제
      if (!target) {
        canvas.discardActiveObject()
        canvas.requestRenderAll()
        return
      }
      
      // 객체 선택
      if (activeObj !== target) {
        canvas.setActiveObject(target)
        target.setCoords()
        canvas.requestRenderAll()
      }
    })
    
    // mouse:up 이벤트
    page.canvas.on('mouse:up', () => {
      if (isResizing) {
        const activeObj = page.canvas!.getActiveObject()
        if (activeObj) {
          activeObj.lockMovementX = false
          activeObj.lockMovementY = false
          activeObj.setCoords()
          page.canvas!.requestRenderAll()
        }
      }
      isResizing = false
      resizeCorner = null
    })
    
    // object:moving 이벤트 - 이동 시 캔버스 경계 제한
    page.canvas.on('object:moving', (opt: any) => {
      const obj = opt.target
      if (!obj) return
      
      const objWidth = (obj.width || 0) * (obj.scaleX || 1)
      const objHeight = (obj.height || 0) * (obj.scaleY || 1)
      
      let left = obj.left || 0
      let top = obj.top || 0
      
      // 경계 제한
      if (left < 0) left = 0
      if (top < 0) top = 0
      if (left + objWidth > CANVAS_WIDTH) left = CANVAS_WIDTH - objWidth
      if (top + objHeight > CANVAS_HEIGHT) top = CANVAS_HEIGHT - objHeight
      
      obj.set({ left, top })
      obj.setCoords()
    })
    
    // 리사이즈 중 객체 참조 저장 (선택 해제 방지용)
    let resizingObject: fabric.Object | null = null
    
    // 선택 해제 전 이벤트 - 리사이즈 중이면 선택 유지
    page.canvas.on('before:selection:cleared', () => {
      if (isResizing) {
        resizingObject = page.canvas!.getActiveObject()
      }
    })
    
    // 선택 해제 후 - 리사이즈 중이었으면 다시 선택
    page.canvas.on('selection:cleared', () => {
      if (isResizing && resizingObject) {
        setTimeout(() => {
          if (page.canvas && resizingObject) {
            page.canvas.setActiveObject(resizingObject)
            page.canvas.requestRenderAll()
          }
          resizingObject = null
        }, 0)
      }
    })
    
  } finally {
    isInitializingCanvas = false
  }
}

// 페이지 영수증 목록 업데이트
const updatePageReceipts = () => {
  const page = currentPage.value
  if (page && page.canvas) {
    page.receipts = page.canvas.getObjects().map((obj: any) => obj.fileName).filter(Boolean)
  }
}

// 선택된 객체 삭제
const deleteSelectedFromCanvas = () => {
  const page = currentPage.value
  if (!page || !page.canvas) return
  
  const activeObjects = page.canvas.getActiveObjects()
  if (activeObjects.length === 0) return
  
  activeObjects.forEach((obj: any) => {
    page.canvas?.remove(obj)
  })
  
  page.canvas.discardActiveObject()
  page.canvas.requestRenderAll()
  updatePageReceipts()
  hasSelectedObject.value = false
}

// 기존 이미지들을 그리드 레이아웃으로 재배치
const rearrangeToGrid = async (canvas: fabric.Canvas, marginX: number, marginY: number, cols: number) => {
  const objects = canvas.getObjects()
  if (objects.length === 0) return
  
  // 그리드 셀 크기 계산 (2행 기준)
  const cellWidth = (CANVAS_WIDTH - marginX * (cols + 1)) / cols
  const cellHeight = (CANVAS_HEIGHT - marginY * 3) / 2  // 2행
  
  // 각 객체를 그리드 위치로 이동
  objects.forEach((obj: any, idx: number) => {
    const col = idx % cols
    const row = Math.floor(idx / cols)
    
    // 원본 이미지 크기 가져오기
    const imgEl = obj._element || obj.getElement?.()
    const originalWidth = imgEl?.naturalWidth || obj.width || 100
    const originalHeight = imgEl?.naturalHeight || obj.height || 100
    
    // 새 스케일 계산
    const scaleX = cellWidth / originalWidth
    const scaleY = cellHeight / originalHeight
    const newScale = Math.min(scaleX, scaleY, 1)
    
    const scaledWidth = originalWidth * newScale
    const scaledHeight = originalHeight * newScale
    
    // 셀 시작 위치
    const cellStartX = marginX + col * (cellWidth + marginX)
    const cellStartY = marginY + row * (cellHeight + marginY)
    
    // 셀 내 중앙 정렬
    const newLeft = cellStartX + (cellWidth - scaledWidth) / 2
    const newTop = cellStartY + (cellHeight - scaledHeight) / 2
    
    // 애니메이션 효과로 이동
    obj.animate({
      left: newLeft,
      top: newTop,
      scaleX: newScale,
      scaleY: newScale
    }, {
      duration: 200,
      onChange: () => canvas.requestRenderAll(),
      easing: fabric.util.ease.easeOutCubic
    })
  })
  
  // 애니메이션 완료 대기
  await new Promise(resolve => setTimeout(resolve, 250))
}

// 영수증을 현재 캔버스에 추가 (imageDataUrl 있으면 자른 이미지 사용)
const addReceiptToCurrentCanvas = async (
  receipt: Receipt,
  checkDuplicate = true,
  imageDataUrl?: string
) => {
  const page = currentPage.value
  if (!page || !page.canvas) return
  
  // 중복 체크
  if (checkDuplicate && page.receipts.includes(receipt.fileName)) {
    return
  }
  
  const imageUrl = imageDataUrl || getReceiptImageUrl(receipt)
  
  try {
    if (!page.canvas) return
    
    // 현재 캔버스에 있는 이미지 개수 (위치 계산용)
    const objectCount = page.canvas.getObjects().length
    
    // 그리드 배치 계산 (2열)
    const marginX = 15
    const marginY = 15
    const cols = 2
    
    // 이미지 크기 계산
    const tempImg = new Image()
    tempImg.crossOrigin = 'anonymous'
    await new Promise<void>((resolve, reject) => {
      tempImg.onload = () => resolve()
      tempImg.onerror = reject
      tempImg.src = imageUrl
    })
    
    if (!page.canvas) return
    
    const imgWidth = tempImg.width || 100
    const imgHeight = tempImg.height || 100
    
    let scale: number
    let posX: number
    let posY: number
    
    // ★ 첫 번째 이미지(1장만)인 경우: 높이 꽉 차게 + 좌우 중앙 정렬
    if (objectCount === 0) {
      // 높이에 맞춰 스케일 계산 (여백 포함)
      const availableHeight = CANVAS_HEIGHT - marginY * 2
      const availableWidth = CANVAS_WIDTH - marginX * 2
      
      // 높이 기준으로 스케일 계산, 가로가 넘치면 가로 기준으로
      const scaleByHeight = availableHeight / imgHeight
      const scaleByWidth = availableWidth / imgWidth
      scale = Math.min(scaleByHeight, scaleByWidth)
      
      const scaledWidth = imgWidth * scale
      const scaledHeight = imgHeight * scale
      
      // 좌우 중앙 정렬
      posX = (CANVAS_WIDTH - scaledWidth) / 2
      // 상하 중앙 정렬 (높이 꽉 차면 marginY)
      posY = (CANVAS_HEIGHT - scaledHeight) / 2
      if (posY < marginY) posY = marginY
    } else {
      // ★ 2번째 이미지 추가 시: 기존 1번째 이미지를 그리드 위치로 재배치
      if (objectCount === 1) {
        await rearrangeToGrid(page.canvas!, marginX, marginY, cols)
      }
      
      // ★ 2개 이상인 경우: 그리드 배치
      const col = objectCount % cols
      const row = Math.floor(objectCount / cols)
      
      // 예상되는 총 행 수 (현재 + 1개 추가 기준)
      const totalRows = row + 1
      
      // 캔버스에 맞게 스케일 계산
      const cellWidth = (CANVAS_WIDTH - marginX * (cols + 1)) / cols
      const maxRows = Math.max(totalRows, 2)
      const cellHeight = (CANVAS_HEIGHT - marginY * (maxRows + 1)) / maxRows
      
      // 이미지 비율 유지하면서 셀에 맞춤
      const scaleX = cellWidth / imgWidth
      const scaleY = cellHeight / imgHeight
      scale = Math.min(scaleX, scaleY, 1)
      
      const scaledWidth = imgWidth * scale
      const scaledHeight = imgHeight * scale
      
      // 위치 계산 (셀 중앙 정렬)
      const cellStartX = marginX + col * (cellWidth + marginX)
      const cellStartY = marginY + row * (cellHeight + marginY)
      
      posX = cellStartX + (cellWidth - scaledWidth) / 2
      posY = cellStartY + (cellHeight - scaledHeight) / 2
      
      // 캔버스 경계 체크
      if (posX + scaledWidth > CANVAS_WIDTH - marginX) {
        posX = CANVAS_WIDTH - scaledWidth - marginX
      }
      if (posX < marginX) posX = marginX
      
      if (posY + scaledHeight > CANVAS_HEIGHT - marginY) {
        posY = CANVAS_HEIGHT - scaledHeight - marginY
      }
      if (posY < marginY) posY = marginY
    }
    
    // Fabric.js v5: 콜백 방식 - Promise로 감싸서 완료 대기
    await new Promise<void>((resolve) => {
      fabric.Image.fromURL(imageUrl, (img: fabric.Image) => {
        if (!img) {
          console.error('❌ fabric.Image.fromURL 실패:', imageUrl)
          resolve()
          return
        }
        
        if (!page.canvas) {
          console.error('❌ 캔버스가 없음')
          resolve()
          return
        }
        
        // 이미지 엘리먼트 확인
        const imgElement = img.getElement() as HTMLImageElement
        
        // left/top 기준으로 위치 계산
        const leftPos = posX
        
        img.set({
          left: leftPos,
          top: posY,
          originX: 'left',
          originY: 'top',
          scaleX: scale,
          scaleY: scale,
          // Fabric.js 기본 컨트롤 완전 비활성화 (커스텀 핸들 사용)
          hasControls: false,
          hasBorders: false,
          // 회전 비활성화
          lockRotation: true,
          hasRotatingPoint: false,
          // Fabric.js 기본 스케일링 비활성화 (커스텀 구현 사용)
          lockScalingX: true,
          lockScalingY: true,
          // 커서 설정
          hoverCursor: 'default',
          moveCursor: 'default'
        })
        
        // @ts-ignore
        img.fileName = receipt.fileName
        // @ts-ignore - 캔버스 내 순번 (사용 가능한 가장 작은 번호)
        img.canvasIndex = getNextAvailableIndex(page.canvas!)
        
        page.canvas!.add(img)
        
        // 중요: setCoords 호출하여 컨트롤 좌표 계산
        img.setCoords()
        
        page.canvas!.setActiveObject(img)
        page.canvas!.requestRenderAll()
        
        // 영수증 목록 업데이트
        if (!page.receipts.includes(receipt.fileName)) {
          page.receipts.push(receipt.fileName)
        }
        
        resolve()
      }, imageDataUrl ? undefined : { crossOrigin: 'anonymous' })
    })
    
  } catch (error) {
    console.error('이미지 로드 오류:', error)
  }
}

// 영수증을 캔버스에서 제거
const removeReceiptFromCanvas = (receipt: Receipt) => {
  for (const page of canvasPages.value) {
    if (page.canvas && page.receipts.includes(receipt.fileName)) {
      const obj = page.canvas.getObjects().find((o: any) => o.fileName === receipt.fileName)
      if (obj) {
        page.canvas.remove(obj)
        page.receipts = page.receipts.filter(f => f !== receipt.fileName)
        
        // ★ 1개만 남으면 꽉 차게 확대
        const remainingObjects = page.canvas.getObjects()
        if (remainingObjects.length === 1) {
          expandSingleImage(page.canvas, remainingObjects[0] as fabric.Image)
        }
        
        page.canvas.renderAll()
      }
      break
    }
  }
}

// 1개 남은 이미지를 꽉 차게 확대
const expandSingleImage = (canvas: fabric.Canvas, img: fabric.Image) => {
  const marginX = 15
  const marginY = 15
  
  // 원본 이미지 크기 가져오기
  const imgEl = (img as any)._element || img.getElement?.()
  const originalWidth = imgEl?.naturalWidth || img.width || 100
  const originalHeight = imgEl?.naturalHeight || img.height || 100
  
  // 높이에 맞춰 스케일 계산
  const availableHeight = CANVAS_HEIGHT - marginY * 2
  const availableWidth = CANVAS_WIDTH - marginX * 2
  
  const scaleByHeight = availableHeight / originalHeight
  const scaleByWidth = availableWidth / originalWidth
  const newScale = Math.min(scaleByHeight, scaleByWidth)
  
  const scaledWidth = originalWidth * newScale
  const scaledHeight = originalHeight * newScale
  
  // 좌우 중앙 정렬
  const newLeft = (CANVAS_WIDTH - scaledWidth) / 2
  let newTop = (CANVAS_HEIGHT - scaledHeight) / 2
  if (newTop < marginY) newTop = marginY
  
  // 애니메이션으로 확대
  img.animate({
    left: newLeft,
    top: newTop,
    scaleX: newScale,
    scaleY: newScale
  }, {
    duration: 200,
    onChange: () => canvas.requestRenderAll(),
    easing: fabric.util.ease.easeOutCubic
  })
}

// 캔버스에서 사용 가능한 가장 작은 번호 찾기
const getNextAvailableIndex = (canvas: fabric.Canvas): number => {
  const usedIndices = new Set<number>()
  canvas.getObjects().forEach((obj: any) => {
    if (obj.canvasIndex) {
      usedIndices.add(obj.canvasIndex)
    }
  })
  
  // 1부터 시작해서 사용되지 않은 가장 작은 번호 찾기
  let index = 1
  while (usedIndices.has(index)) {
    index++
  }
  return index
}

// 영수증 클릭 → 미매칭은 캔버스 토글, 매칭됨은 통장 자동선택 + 캔버스 표시
const handleReceiptClick = async (receipt: Receipt) => {
  if (loadingReceiptFile.value || isCropping.value) return

  // 이미 맞춘 영수증 → 해당 매칭으로 이동 (통장 선택 + 캔버스)
  if (isReceiptMatchedFlag(receipt)) {
    loadingReceiptFile.value = receipt.fileName
    try {
      await focusMatchedReceipt(receipt)
    } finally {
      loadingReceiptFile.value = null
    }
    return
  }

  if (isReceiptInAnyCanvas(receipt)) {
    removeReceiptFromCanvas(receipt)
    return
  }

  if (isAlreadyMatched.value) {
    showSnackbar('맞춘 항목입니다. 다시 묶으려면 먼저 「해제」하세요.', 'error')
    return
  }

  loadingReceiptFile.value = receipt.fileName
  try {
    if (canvasPages.value.length === 0) {
      await initFirstPage()
    }
    await addReceiptToCurrentCanvas(receipt)
  } catch (error) {
    console.error('캔버스 추가 오류:', error)
    showSnackbar('영수증을 캔버스에 넣지 못했습니다.', 'error')
  } finally {
    loadingReceiptFile.value = null
  }
}

// 영수증 클릭 처리 (기존 방식 - 호환성 유지)
const toggleReceiptInCanvas = async (receipt: Receipt) => {
  await handleReceiptClick(receipt)
}

/** 맞춘 영수증 클릭 → 연결 통장 선택 + 매칭 로드(캔버스 표시) */
const focusMatchedReceipt = async (receipt: Receipt) => {
  // 이미 이 매칭을 보고 있으면 캔버스만 확인
  const sameGroup =
    receipt.isCurrentMatched &&
    existingMatching.value &&
    (Number((existingMatching.value as any).crm_code || (existingMatching.value as any).crm_idx) === Number(receipt.crmIdx)
      || matchedImages.value.some((m) => m.fileName === receipt.fileName))

  if (sameGroup) {
    // 캔버스에 없으면 다시 로드
    if (!isReceiptInAnyCanvas(receipt) && !matchedImages.value.some((m) => isMergedReceipt(m) && isReceiptInAnyCanvas(m))) {
      await loadExistingMatching()
    }
    // 합성 묶음이 캔버스에 있으면 OK, 개별만 보이길 원하면 해당 장 추가
    if (isMergedReceipt(receipt) && !isReceiptInAnyCanvas(receipt)) {
      if (canvasPages.value.length === 0) await initFirstPage()
      await addReceiptToCurrentCanvas(receipt, true)
    } else if (!isMergedReceipt(receipt) && !isReceiptInAnyCanvas(receipt)) {
      // 원본 클릭 시: 합성이 있으면 합성을 우선 표시 (이미 load에서 처리됨)
      const merged = matchedImages.value.find((m) => isMergedReceipt(m))
      if (merged && !isReceiptInAnyCanvas(merged)) {
        if (canvasPages.value.length === 0) await initFirstPage()
        await addReceiptToCurrentCanvas(merged, true)
      }
    }
    return
  }

  let targetCashbook = cashbookListForMatching.value.find(
    (cb) => Number(cb.cb_idx) === Number(receipt.matchedCbIdx)
  )

  // matchedCbIdx 없으면 같은 crmIdx로 통장 탐색
  if (!targetCashbook && receipt.crmIdx) {
    targetCashbook = cashbookListForMatching.value.find(
      (cb) => Number((cb as any).crm_idx || (cb as any).crm_code) === Number(receipt.crmIdx)
    )
  }

  // 같은 날짜·이미 매칭된 통장 중 서버 조회로 연결 확인
  if (!targetCashbook && receipt.crmIdx) {
    const receiptDate = receipt.scanDate?.split(' ')[0] || ''
    const candidates = cashbookListForMatching.value.filter((cb) => {
      if (!isCashbookReceiptMatched(cb)) return false
      if (receiptDate && cb.cb_date && cb.cb_date !== receiptDate) return false
      return true
    })
    for (const cb of candidates) {
      if (!cb.cb_idx) continue
      try {
        const res = await api.get(`/receipt-matching/by-cashbook/${cb.cb_idx}`)
        const crm = res.data?.data?.crm_code || res.data?.data?.crm_idx
        if (res.data?.success && res.data?.data && Number(crm) === Number(receipt.crmIdx)) {
          targetCashbook = cb
          receipt.matchedCbIdx = cb.cb_idx
          break
        }
      } catch {
        /* skip */
      }
    }
  }

  if (!targetCashbook) {
    showSnackbar('연결된 통장내역을 찾지 못했습니다.', 'error')
    return
  }

  // 선택·캔버스 초기화 후 매칭 로드
  selectedCashbookItems.value = []
  disposeAllCanvases()
  canvasPages.value = []
  currentPageIndex.value = 0
  existingMatching.value = null
  matchedImages.value = []

  skipFilterWatchReset.value = true
  cashbookFilterMatched.value = 'matched'
  receiptFilterMatched.value = 'matched'
  await nextTick()
  skipFilterWatchReset.value = false

  selectedCashbookItems.value = [targetCashbook]
  filterDate.value = targetCashbook.cb_date || ''

  await loadExistingMatching()
  // loadExistingMatching이 통장 N건 선택 + 합성 이미지를 캔버스에 올림
}

// 하위 호환 별칭
const switchToMatchedCashbook = focusMatchedReceipt

// 전체 캔버스 초기화
const clearAllCanvases = () => {
  if (!confirm('모든 페이지의 영수증을 삭제하시겠습니까?')) return
  
  canvasPages.value.forEach(page => {
    if (page.canvas) {
      page.canvas.clear()
      page.canvas.backgroundColor = '#ffffff'
      page.canvas.renderAll()
    }
    page.receipts = []
  })
  
  // 첫 페이지만 남기기
  while (canvasPages.value.length > 1) {
    const page = canvasPages.value.pop()
    if (page?.canvas) {
      page.canvas.dispose()
    }
  }
  currentPageIndex.value = 0
}

// 키보드 이벤트 핸들러
const handleKeydown = (e: KeyboardEvent) => {
  const target = e.target as HTMLElement
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return
  
  if (e.key === 'Delete' || e.key === 'Backspace') {
    e.preventDefault()
    deleteSelectedObject()
  }
}

// 선택된 객체 삭제
const deleteSelectedObject = () => {
  const page = currentPage.value
  if (!page || !page.canvas) return
  
  const activeObject = page.canvas.getActiveObject()
  if (!activeObject) return
  
  // @ts-ignore
  const fileName = activeObject.fileName
  
  page.canvas.remove(activeObject)
  
  if (fileName) {
    page.receipts = page.receipts.filter(f => f !== fileName)
  }
  
  page.canvas.renderAll()
}

// 통장내역 목록 로드
const loadCashbookList = async () => {
  if (!props.mCode) return
  
  loadingCashbook.value = true
  try {
    let year: string, month: string
    
    // 1순위: 선택된 항목의 날짜
    const cbDate = props.cashbookItem?.cb_date
    if (cbDate && cbDate.length >= 7) {
      const parts = cbDate.split('-')
      year = parts[0]
      month = String(parseInt(parts[1], 10))
    } else if (props.currentYear && props.currentMonth) {
      // 2순위: 부모에서 전달받은 연월
      year = props.currentYear
      month = String(parseInt(props.currentMonth, 10))
    } else {
      // 3순위: 현재 날짜
      const now = new Date()
      year = String(now.getFullYear())
      month = String(now.getMonth() + 1)
    }
    
    const params: Record<string, string> = { year, month }
    if (props.bizGubun) {
      params.bizGubun = props.bizGubun
    }
    
    // mCode (내부 PK)를 사용해야 함 - mCode(시설번호)가 아님!
    const response = await api.get(`/bankbook/list/${props.mCode}`, { params })
    
    let items: CashbookItem[] = []
    if (response.data?.success && response.data?.data) {
      items = response.data.data
    } else if (Array.isArray(response.data)) {
      items = response.data
    }
    
    // 영수증 매칭은 '지출(OUT)'만 해당 - 수입은 영수증이 없음
    cashbookListForMatching.value = items
      .filter(item => item.cb_gubun === 'OUT')
      .map(item => ({
        ...item,
        cb_receipt_matched: Number(item.cb_receipt_matched) === 1 ? 1 : 0,
        cb_price: Number(item.cb_price) || 0,
      }))

    // 매칭 테이블 기준으로 플래그 보정 (시드 재생성 등으로 어긋난 경우)
    await syncCashbookMatchFlagsFromServer(year, month)
  } catch (error) {
    console.error('통장내역 목록 로드 오류:', error)
    cashbookListForMatching.value = []
  } finally {
    loadingCashbook.value = false
  }
}

// 월별 매칭 목록으로 통장 플래그 보정
const syncCashbookMatchFlagsFromServer = async (year: string, month: string) => {
  if (!props.mCode || cashbookListForMatching.value.length === 0) return
  try {
    const res = await api.get(`/receipt-matching/month/${props.mCode}`, {
      params: {
        year,
        month: String(month).padStart(2, '0'),
        bizGubun: props.bizGubun || undefined,
      },
    })
    const rows = res.data?.data || []
    const matchedCb = new Set<number>()
    for (const row of rows) {
      const raw = String(row.cashbook_idxs || row.crm_cashbook_idxs || '')
      raw.split(',').forEach((part: string) => {
        const n = Number(part)
        if (n > 0) matchedCb.add(n)
      })
    }
    cashbookListForMatching.value = cashbookListForMatching.value.map((item) => ({
      ...item,
      // 월별 매칭 테이블이 있으면 그걸 기준으로 (없으면 기존 플래그 유지)
      cb_receipt_matched: matchedCb.size > 0
        ? (matchedCb.has(Number(item.cb_idx)) ? 1 : 0)
        : (Number(item.cb_receipt_matched) === 1 ? 1 : 0),
    }))
  } catch (error) {
    console.error('통장 매칭 플래그 동기화 오류:', error)
  }
}

// 통장내역 항목 선택/해제 (날짜가 달라도 N건 선택 가능)
const toggleCashbookItem = async (item: CashbookItem) => {
  const isAlreadySelected = selectedCashbookItems.value.some(i => i.cb_idx === item.cb_idx)

  // 이미 선택된 항목 → 개별 해제
  if (isAlreadySelected) {
    selectedCashbookItems.value = selectedCashbookItems.value.filter(i => i.cb_idx !== item.cb_idx)
    if (selectedCashbookItems.value.length === 0) {
      existingMatching.value = null
      matchedImages.value = []
      filterDate.value = ''
      return
    }
    // 남은 선택이 전부 미매칭이면 뷰어 상태 해제
    if (!selectedCashbookItems.value.every(i => isCashbookReceiptMatched(i))) {
      existingMatching.value = null
      matchedImages.value = []
    }
    filterDate.value = selectedCashbookItems.value[0]?.cb_date || ''
    return
  }

  // 다른 항목이 이미 선택된 경우
  if (selectedCashbookItems.value.length > 0) {
    // 맞춘 항목 보기 중 → 추가 선택 대신 해당 항목으로 교체(맞춘 건) 또는 차단
    if (isAlreadyMatched.value) {
      if (isCashbookReceiptMatched(item)) {
        selectedCashbookItems.value = [item]
        filterDate.value = item.cb_date || ''
        await loadExistingMatching()
        return
      }
      showSnackbar('맞춘 항목 보기 중입니다. 먼저 「해제」한 뒤 다시 선택하세요.', 'error')
      return
    }
    // 미매칭 다중 선택 중 맞춘 항목 추가 불가
    if (isCashbookReceiptMatched(item)) {
      showSnackbar('미매칭 통장과 맞춘 통장은 함께 선택할 수 없습니다.', 'error')
      return
    }
    selectedCashbookItems.value = [...selectedCashbookItems.value, item]
    filterDate.value = item.cb_date || ''
    return
  }

  // 첫 선택
  selectedCashbookItems.value = [item]
  filterDate.value = item.cb_date || ''

  // 서버 매칭 확인 (플래그와 어긋나도 맞춤 정보 표시)
  await loadExistingMatching()
  if (existingMatching.value) {
    item.cb_receipt_matched = 1
    const idx = cashbookListForMatching.value.findIndex(i => i.cb_idx === item.cb_idx)
    if (idx !== -1) cashbookListForMatching.value[idx].cb_receipt_matched = 1
    skipFilterWatchReset.value = true
    cashbookFilterMatched.value = 'matched'
    receiptFilterMatched.value = 'matched'
    await nextTick()
    skipFilterWatchReset.value = false
  } else {
    item.cb_receipt_matched = 0
    existingMatching.value = null
    matchedImages.value = []
  }
}

// 통장내역 전체 선택 해제
const clearCashbookSelection = () => {
  selectedCashbookItems.value = []
  filterDate.value = ''
  existingMatching.value = null
  matchedImages.value = []
}

// 영수증 로드 (매칭된 것 포함 전체 - 필터는 프론트엔드에서 적용)
const loadUnmatchedReceipts = async () => {
  if (!props.mCode) return
  
  loadingReceipts.value = true
  try {
    // 사업구분 필터 적용하여 로드
    const params: any = {
      includeMatched: true,  // 매칭된 것도 포함
    }
    if (props.currentYear && props.currentMonth) {
      params.yearMonth = `${props.currentYear}-${String(props.currentMonth).padStart(2, '0')}`
    }
    
    // 사업구분 필터 적용
    if (props.bizGubun) {
      params.bizGubun = props.bizGubun
    }
    
    const response = await api.get(`/receipt-matching/unmatched-scan/${props.mCode}`, { params })
    
    if (response.data.success) {
      const selectedDate = filterDate.value
      const currentCbIdx = selectedCashbookItems.value[0]?.cb_idx
      
      receiptList.value = (response.data.data || []).map((receipt: any) => ({
        idx: receipt.idx || receipt.csi_idx,
        fileName: receipt.fileName || receipt.csi_file_name,
        fileUrl: receipt.fileUrl,
        mCode: receipt.mCode || receipt.csi_m_code,
        scanDate: receipt.scanDate || receipt.csi_scan_date,
        description: receipt.description || receipt.csi_description,
        matched: Number(receipt.matched ?? 0) === 1 ? 1 : 0,  // 숫자로 정규화
        matchCount: receipt.matchCount ?? 0,
        crmIdx: receipt.crmIdx ?? receipt.crm_code ?? null,
        matchedCbIdx: receipt.matchedCbIdx ?? receipt.cb_idx ?? null,
        isDateMatch: selectedDate ? ((receipt.scanDate || receipt.csi_scan_date)?.split(' ')[0] === selectedDate) : false,
        isCurrentMatched: currentCbIdx ? (receipt.matchedCbIdx === currentCbIdx || receipt.cb_idx === currentCbIdx) : false
      }))
    }
  } catch (error) {
    console.error('영수증 로드 오류:', error)
    receiptList.value = []
  } finally {
    loadingReceipts.value = false
  }
}

// 기존 매칭 정보 로드
const parseCashbookIdxList = (raw: unknown): number[] => {
  if (Array.isArray(raw)) {
    return raw.map((n) => Number(n)).filter((n) => n > 0)
  }
  if (typeof raw === 'string') {
    return raw.split(',').map((s) => Number(s.trim())).filter((n) => n > 0)
  }
  return []
}

const loadExistingMatching = async () => {
  const currentItem = selectedCashbookItems.value[0]
  if (!currentItem?.cb_idx) return
  
  loadingReceipts.value = true
  try {
    const response = await api.get(`/receipt-matching/by-cashbook/${currentItem.cb_idx}`)
    
    if (response.data.success && response.data.data) {
      existingMatching.value = response.data.data
      const currentCrmIdx = response.data.data.crm_code || response.data.data.crm_idx

      // N:N — 같은 매칭에 묶인 통장내역을 모두 선택
      const linkedIdxs = parseCashbookIdxList(
        response.data.data.cashbook_idxs_array || response.data.data.cashbook_idxs
      )
      if (linkedIdxs.length > 0) {
        const linked = cashbookListForMatching.value.filter((cb) =>
          linkedIdxs.includes(Number(cb.cb_idx))
        )
        if (linked.length > 0) {
          selectedCashbookItems.value = linked
          filterDate.value = linked[0]?.cb_date || currentItem.cb_date || ''
        }
      }
      
      // 합성 이미지 정보 저장
      const mergedImages = (response.data.data.scan_images || []).map((img: any) => ({
        idx: img.csi_idx,
        fileName: img.csi_file_name,
        fileUrl: `/api/scan/image/${props.mCode}/${img.csi_file_name}`,
        scanDate: img.csi_scan_date,
        description: img.csi_description,
        matched: 1,
        crmIdx: currentCrmIdx,
        matchedCbIdx: currentItem.cb_idx,
        isDateMatch: img.csi_scan_date === currentItem.cb_date,
        isCurrentMatched: true
      }))
      
      // 원본 이미지 정보 저장
      const sourceImages = (response.data.data.source_images || []).map((img: any) => ({
        idx: img.csi_idx,
        fileName: img.csi_file_name,
        fileUrl: `/api/scan/image/${props.mCode}/${img.csi_file_name}`,
        scanDate: img.csi_scan_date,
        description: img.csi_description,
        matched: 1,
        crmIdx: currentCrmIdx,
        matchedCbIdx: currentItem.cb_idx,
        isDateMatch: img.csi_scan_date === currentItem.cb_date,
        isCurrentMatched: true
      }))
      
      // 합성 + 원본 모두 저장
      matchedImages.value = [...mergedImages, ...sourceImages]
      
      const currentMatchedFileNames = matchedImages.value.map((img: Receipt) => img.fileName)
      
      // 탭 초기화 (합성 이미지가 있으면 합성 탭, 없으면 원본 탭)
      matchedImageTab.value = mergedImages.length > 0 ? 'merged' : 'source'
      previewImageType.value = matchedImageTab.value
      previewImageIndex.value = 0
      
      // 영수증 목록도 로드하여 현재 매칭된 영수증 표시
      await loadUnmatchedReceipts()
      
      // 로드된 영수증 목록에서 현재 매칭된 영수증 표시 (+ crmIdx 동기화)
      receiptList.value = receiptList.value.map(receipt => {
        const matched = matchedImages.value.find((m) => m.fileName === receipt.fileName)
        return {
          ...receipt,
          isCurrentMatched: currentMatchedFileNames.includes(receipt.fileName),
          crmIdx: matched?.crmIdx ?? receipt.crmIdx,
          matched: currentMatchedFileNames.includes(receipt.fileName) ? 1 : receipt.matched,
        }
      })
      
      // 매칭된 영수증이 목록에 없으면 추가
      for (const matchedImg of matchedImages.value) {
        const exists = receiptList.value.some(r => r.fileName === matchedImg.fileName)
        if (!exists) {
          receiptList.value.unshift(matchedImg)
        } else {
          // 기존 항목에도 crmIdx·현재매칭 반영
          const idx = receiptList.value.findIndex((r) => r.fileName === matchedImg.fileName)
          if (idx >= 0) {
            receiptList.value[idx] = {
              ...receiptList.value[idx],
              ...matchedImg,
              isCurrentMatched: true,
            }
          }
        }
      }
      
      // 캔버스 초기화 후 매칭된 합성 영수증을 캔버스에 표시
      disposeAllCanvases()
      canvasPages.value = []
      await nextTick()
      initFirstPage()
      
      // 합성 영수증만 캔버스에 추가 (원본 영수증은 목록에서 펼쳐볼 수 있음)
      for (const matchedImg of matchedImages.value) {
        if (isMergedReceipt(matchedImg)) {
          await addReceiptToCurrentCanvas(matchedImg)
        }
      }
      
      // 합성 영수증이 없으면 원본 영수증들을 추가
      const hasMerged = matchedImages.value.some(img => isMergedReceipt(img))
      if (!hasMerged && matchedImages.value.length > 0) {
        for (const matchedImg of matchedImages.value) {
          await addReceiptToCurrentCanvas(matchedImg)
        }
      }
    } else {
      // 미매칭 통장 — 사용자가 이미 올린 영수증이 있으면 캔버스 유지
      existingMatching.value = null
      matchedImages.value = []
      await loadUnmatchedReceipts()
      if (totalReceiptsInCanvas.value === 0 && canvasPages.value.length === 0) {
        await initFirstPage()
      }
    }
  } catch (error) {
    console.error('매칭 정보 로드 오류:', error)
    await loadUnmatchedReceipts()
    if (totalReceiptsInCanvas.value === 0 && canvasPages.value.length === 0) {
      await initFirstPage()
    }
  } finally {
    loadingReceipts.value = false
  }
}

// 캔버스 렌더링 완료 대기 함수
const waitForCanvasRender = (canvas: fabric.Canvas): Promise<void> => {
  return new Promise((resolve) => {
    const objects = canvas.getObjects()
    
    // 모든 이미지 객체의 로딩 완료 확인
    const imageLoadPromises: Promise<void>[] = []
    
    objects.forEach((obj: any, idx: number) => {
      // Fabric.js Image 객체의 실제 이미지 엘리먼트 확인
      const imgElement = obj._element || obj.getElement?.()
      
      if (imgElement instanceof HTMLImageElement) {
        if (!imgElement.complete || imgElement.naturalWidth === 0) {
          // 이미지가 아직 로드 중
          imageLoadPromises.push(new Promise<void>((imgResolve) => {
            const onLoad = () => {
              imgElement.removeEventListener('load', onLoad)
              imgElement.removeEventListener('error', onError)
              imgResolve()
            }
            const onError = () => {
              imgElement.removeEventListener('load', onLoad)
              imgElement.removeEventListener('error', onError)
              imgResolve()
            }
            imgElement.addEventListener('load', onLoad)
            imgElement.addEventListener('error', onError)
            
            // 타임아웃 (5초)
            setTimeout(() => {
              imgElement.removeEventListener('load', onLoad)
              imgElement.removeEventListener('error', onError)
              imgResolve()
            }, 5000)
          }))
        }
      }
    })
    
    // 모든 이미지 로드 완료 대기
    Promise.all(imageLoadPromises).then(() => {
      // 강제 렌더링 - 여러 번 호출
      canvas.renderAll()
      canvas.requestRenderAll()
      
      // ★ 충분한 시간 대기 (500ms) - 브라우저가 실제로 픽셀을 그릴 시간 필요
      setTimeout(() => {
        canvas.renderAll()
        canvas.requestRenderAll()
        
        // 한 번 더 대기
        setTimeout(() => {
          resolve()
        }, 200)
      }, 300)
    })
  })
}

// 합성 영수증 이름 입력 다이얼로그 열기 (또는 1장이면 바로 저장)
const openMergedNameDialog = () => {
  if (totalReceiptsInCanvas.value === 0 || selectedCashbookItems.value.length === 0) return
  
  if (hasMatchedInSelection.value) {
    alert('이미 매칭된 통장내역 항목이 포함되어 있습니다.')
    return
  }
  
  // ★ 1장이면 합성 없이 바로 저장 (이름 입력 불필요)
  if (totalReceiptsInCanvas.value === 1 && canvasPages.value.length === 1) {
    saveMatchingWithMerge()
    return
  }
  
  // 2장 이상이면 합성 영수증 이름 입력 다이얼로그 표시
  const firstItem = selectedCashbookItems.value[0]
  const n = selectedCashbookItems.value.length
  const baseName = firstItem?.cb_briefs || firstItem?.cb_memo || '영수증'
  mergedReceiptName.value = n > 1 ? `${baseName} 외 ${n - 1}건` : baseName
  mergedNameDialog.value = true
}

// 합성 영수증 이름 입력 취소
const cancelMergedName = () => {
  mergedNameDialog.value = false
  mergedReceiptName.value = ''
}

// 합성 영수증 이름 확인 후 매칭 저장
const confirmMergedName = () => {
  mergedNameDialog.value = false
  saveMatchingWithMerge()
}

/** 영수증 날짜와 통장 지출일이 다르면 저장 전에 한 번 확인. 같으면 바로 진행 */
const confirmCrossDateMatch = (): boolean => {
  const { bankDates, receiptDates } = selectedMatchDates()
  const all = new Set([...bankDates, ...receiptDates])
  if (all.size <= 1) return true
  const receiptLabel = receiptDates.join(', ') || '-'
  const bankLabel = bankDates.join(', ') || '-'
  return window.confirm(
    `영수증 날짜와 통장 지출일이 다릅니다.\n영수증: ${receiptLabel}\n통장: ${bankLabel}\n세금계산서 발행일과 실제 출금일이 다를 때 이렇게 맞출 수 있습니다.\n그대로 매칭할까요?`
  )
}

// 매칭 저장 (1장이면 원본 그대로, 2장 이상이면 합성)
const saveMatchingWithMerge = async () => {
  if (totalReceiptsInCanvas.value === 0 || selectedCashbookItems.value.length === 0) return
  
  if (hasMatchedInSelection.value) {
    alert('이미 매칭된 통장내역 항목이 포함되어 있습니다.')
    return
  }

  if (!confirmCrossDateMatch()) return
  
  saving.value = true
  try {
    const firstItem = selectedCashbookItems.value[0]
    
    // ★ 중요: 저장 전에 현재 캔버스 상태를 먼저 저장
    saveCurrentCanvasState()
    
    // 현재 캔버스의 객체 수 확인
    const currentCanvas = currentPage.value?.canvas
    const totalReceipts = totalReceiptsInCanvas.value
    
    // ★ 1장만 있는 경우: 합성 없이 원본 그대로 매칭
    if (totalReceipts === 1 && canvasPages.value.length === 1) {
      const page = canvasPages.value[0]
      let receiptFileName: string | null = null
      
      if (page.canvas) {
        const objects = page.canvas.getObjects()
        if (objects.length > 0) {
          receiptFileName = (objects[0] as any).fileName
        }
      }
      
      if (!receiptFileName && page.receipts.length > 0) {
        receiptFileName = page.receipts[0]
      }
      
      if (!receiptFileName) {
        alert('영수증을 찾을 수 없습니다.')
        return
      }
      
      // 원본 영수증으로 바로 매칭 (합성 없음)
      const matchResponse = await api.post('/receipt-matching', {
        m_code: props.mCode,
        biz_gubun: props.bizGubun,
        date: firstItem.cb_date,
        cashbook_idxs: selectedCashbookItems.value.map(item => item.cb_idx),
        scan_file_names: [receiptFileName],  // 원본 파일명 그대로
        source_receipts: []  // 원본 매칭이므로 소스 없음
      })
      
      if (matchResponse.data.success) {
        // 통장내역 목록 업데이트
        selectedCashbookItems.value.forEach(item => {
          const idx = cashbookListForMatching.value.findIndex(i => i.cb_idx === item.cb_idx)
          if (idx !== -1) {
            cashbookListForMatching.value[idx].cb_receipt_matched = 1
          }
        })
        
        // 영수증 목록 새로고침
        await loadUnmatchedReceipts()
        
        // 매칭 정보 로드
        await loadExistingMatching()
        
        emit('saved', { crm_code: matchResponse.data.data.crm_code })
      }
      
      return
    }
    
    // ★ 2장 이상인 경우: 합성본 생성
    const mergedImages: string[] = []
    const allSourceReceipts: string[] = []
    
    if (currentCanvas) {
      // 현재 캔버스에서 파일명 확인용
    }
    
    // 각 페이지의 영수증 목록을 미리 수집 (페이지 전환 전에)
    const pageReceiptsMap: Map<number, string[]> = new Map()
    for (let i = 0; i < canvasPages.value.length; i++) {
      const page = canvasPages.value[i]
      if (i === currentPageIndex.value && page.canvas) {
        const canvasFileNames = page.canvas.getObjects()
          .map((obj: any) => obj.fileName)
          .filter((name: string | undefined) => !!name)
        pageReceiptsMap.set(i, canvasFileNames)
      } else {
        pageReceiptsMap.set(i, [...page.receipts])
      }
    }
    
    // 각 페이지별로 합성본 생성
    for (let i = 0; i < canvasPages.value.length; i++) {
      const canvasFileNames = pageReceiptsMap.get(i) || []
      
      if (canvasFileNames.length === 0) continue
      
      allSourceReceipts.push(...canvasFileNames)
      
      if (i !== currentPageIndex.value) {
        await switchToPage(i)
        await nextTick()
        await nextTick()
      }
      
      const targetCanvas = canvasPages.value[i].canvas
      if (!targetCanvas) {
        console.warn(`⚠️ 페이지 ${i}의 캔버스가 없습니다.`)
        continue
      }
      
      await waitForCanvasRender(targetCanvas)
      
      const objects = targetCanvas.getObjects()
      
      let minX = 0, minY = 0, maxX = CANVAS_WIDTH, maxY = CANVAS_HEIGHT
      objects.forEach((obj: any) => {
        const bound = obj.getBoundingRect(true, true)
        if (bound) {
          maxX = Math.max(maxX, bound.left + bound.width)
          maxY = Math.max(maxY, bound.top + bound.height)
        }
      })
      
      const lowerCanvas = targetCanvas.getElement()
      
      const exportCanvas = document.createElement('canvas')
      exportCanvas.width = CANVAS_WIDTH * 2
      exportCanvas.height = CANVAS_HEIGHT * 2
      const exportCtx = exportCanvas.getContext('2d')
      
      if (exportCtx) {
        exportCtx.fillStyle = '#ffffff'
        exportCtx.fillRect(0, 0, exportCanvas.width, exportCanvas.height)
        exportCtx.scale(2, 2)
        
        for (const obj of objects) {
          const imgEl = obj._element || obj.getElement?.()
          if (imgEl && imgEl instanceof HTMLImageElement && imgEl.complete && imgEl.naturalWidth > 0) {
            const left = obj.left || 0
            const top = obj.top || 0
            const scaleX = obj.scaleX || 1
            const scaleY = obj.scaleY || 1
            const width = (obj.width || imgEl.naturalWidth) * scaleX
            const height = (obj.height || imgEl.naturalHeight) * scaleY
            
            try {
              exportCtx.drawImage(imgEl, left, top, width, height)
            } catch (e) {
              console.error(`이미지 그리기 실패: ${obj.fileName}`, e)
            }
          }
        }
      }
      
      const dataURL = exportCanvas.toDataURL('image/png', 1.0)
      
      const response = await fetch(dataURL)
      const blob = await response.blob()
      
      const formData = new FormData()
      formData.append('image', blob, `merged_${Date.now()}_page${i + 1}.png`)
      formData.append('scan_date', firstItem.cb_date)
      const descName = mergedReceiptName.value.trim() || '합성영수증'
      const pageInfo = canvasPages.value.length > 1 ? ` (${i + 1}/${canvasPages.value.length})` : ''
      formData.append('description', descName + pageInfo)
      formData.append('source_files', JSON.stringify(canvasFileNames))
      
      const uploadResponse = await api.post(`/receipt-matching/upload-merged/${props.mCode}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      
      if (uploadResponse.data.success) {
        mergedImages.push(uploadResponse.data.data.fileName)
      }
    }
    
    if (mergedImages.length === 0) {
      alert('합성본 생성에 실패했습니다.')
      return
    }
    
    // 매칭 저장
    const matchResponse = await api.post('/receipt-matching', {
      m_code: props.mCode,
      biz_gubun: props.bizGubun,
      date: firstItem.cb_date,
      cashbook_idxs: selectedCashbookItems.value.map(item => item.cb_idx),
      scan_file_names: mergedImages,
      source_receipts: allSourceReceipts
    })
    
    if (matchResponse.data.success) {
      // 통장내역 목록 업데이트
      selectedCashbookItems.value.forEach(item => {
        const idx = cashbookListForMatching.value.findIndex(i => i.cb_idx === item.cb_idx)
        if (idx !== -1) {
          cashbookListForMatching.value[idx].cb_receipt_matched = 1
        }
      })
      
      emit('saved', { crm_code: matchResponse.data.data.crm_code })
      
      // 선택 초기화
      selectedCashbookItems.value = []
      disposeAllCanvases()
      canvasPages.value = []
      await loadUnmatchedReceipts()
      
      alert('매칭이 완료되었습니다.')
    } else {
      alert(matchResponse.data.message || '매칭 저장 실패')
    }
  } catch (error: any) {
    console.error('매칭 저장 오류:', error)
    alert(error.response?.data?.message || '매칭 저장 중 오류가 발생했습니다')
  } finally {
    saving.value = false
  }
}

// 매칭 해제
const unmatchReceipt = async () => {
  if (!existingMatching.value?.crm_code) return
  if (!confirm('영수증 매칭을 해제하시겠습니까?')) return
  
  saving.value = true
  try {
    const response = await api.delete(`/receipt-matching/${existingMatching.value.crm_code}`)
    
    if (response.data.success) {
      selectedCashbookItems.value.forEach(item => {
        const idx = cashbookListForMatching.value.findIndex(i => i.cb_idx === item.cb_idx)
        if (idx !== -1) {
          cashbookListForMatching.value[idx].cb_receipt_matched = 0
        }
      })
      
      selectedCashbookItems.value = selectedCashbookItems.value.map(item => ({
        ...item,
        cb_receipt_matched: 0
      }))
      
      existingMatching.value = null
      matchedImages.value = []
      
      emit('saved', { crm_code: null, unmatched: true })
      
      await loadUnmatchedReceipts()
      initFirstPage()
    } else {
      alert(response.data.message || '매칭 해제 실패')
    }
  } catch (error: any) {
    console.error('매칭 해제 오류:', error)
    alert(error.response?.data?.message || '매칭 해제 중 오류가 발생했습니다')
  } finally {
    saving.value = false
  }
}

// ===== 영수증 자르기 (Cropper.js) =====
const cropModal = ref(false)
const cropImageEl = ref<HTMLImageElement | null>(null)
const currentCropReceipt = ref<Receipt | null>(null)
const isCropping = ref(false)
let cropperInstance: Cropper | null = null

const cropStripReceipts = computed(() => {
  // 매칭된 영수증은 자르기 후보에서 제외
  const list = filteredAndSortedReceipts.value.filter(
    (r) => !isMergedReceipt(r) && !isReceiptMatchedFlag(r)
  )
  return list.slice(0, 24)
})

const destroyCropper = () => {
  if (cropperInstance) {
    cropperInstance.destroy()
    cropperInstance = null
  }
}

const initCropper = async () => {
  destroyCropper()
  await nextTick()
  if (!cropImageEl.value) return
  cropperInstance = new Cropper(cropImageEl.value, {
    aspectRatio: NaN,
    viewMode: 1,
    dragMode: 'move',
    autoCropArea: 1,
    restore: false,
    guides: true,
    center: true,
    highlight: false,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
  })
}

const onCropImageLoad = async () => {
  if (!cropModal.value) return
  await initCropper()
}

const openCropModal = (receipt: Receipt) => {
  if (isReceiptMatchedFlag(receipt)) {
    showSnackbar('이미 맞춘 영수증은 편집할 수 없습니다. 먼저 매칭을 해제하세요.', 'error')
    return
  }
  currentCropReceipt.value = receipt
  cropModal.value = true
}

const closeCropModal = () => {
  cropModal.value = false
  currentCropReceipt.value = null
  destroyCropper()
}

const selectCropReceipt = async (receipt: Receipt) => {
  if (currentCropReceipt.value?.fileName === receipt.fileName) return
  destroyCropper()
  currentCropReceipt.value = receipt
  await nextTick()
}

const rotateCrop = (degree: number) => {
  cropperInstance?.rotate(degree)
}

const cropAndAddToCanvas = async () => {
  if (!currentCropReceipt.value || !cropperInstance) return
  isCropping.value = true
  try {
    const croppedCanvas = cropperInstance.getCroppedCanvas({
      maxWidth: 2048,
      maxHeight: 2048,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high',
    })
    if (!croppedCanvas) {
      alert('자른 이미지를 만들 수 없습니다.')
      return
    }
    const dataUrl = croppedCanvas.toDataURL('image/png', 1)

    if (canvasPages.value.length === 0) {
      await initFirstPage()
    }
    await addReceiptToCurrentCanvas(currentCropReceipt.value, true, dataUrl)
    closeCropModal()
    showSnackbar('캔버스에 넣었습니다. 여러 장을 올린 뒤 「묶어서 매칭」하세요.', 'success')
  } catch (error) {
    console.error('자르기 오류:', error)
    alert('영수증 자르기에 실패했습니다.')
  } finally {
    isCropping.value = false
  }
}

watch(cropModal, async (open) => {
  if (!open) destroyCropper()
})

// 다이얼로그 닫기
const closeDialog = () => {
  closeCropModal()
  dialogVisible.value = false
}

// 유틸리티 함수들
const formatShortDate = (dateStr: string | null): string => {
  if (!dateStr) return '-'
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return dateStr
  return `${d.getMonth() + 1}/${d.getDate()}`
}

const formatNumber = (value: number | string | undefined | null): string => {
  if (value === undefined || value === null) return '0'
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return '0'
  return num.toLocaleString('ko-KR')
}

const formatDate = (value: string | null): string => {
  if (!value) return '-'
  const d = new Date(value)
  if (isNaN(d.getTime())) return value
  return `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일`
}

const formatScanDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '날짜 미등록'
  const date = new Date(dateStr)
  return `${date.getMonth() + 1}/${date.getDate()}`
}

const getReceiptImageUrl = (receipt: Receipt): string => {
  if (receipt.fileUrl) {
    return receipt.fileUrl.startsWith('http') ? receipt.fileUrl : receipt.fileUrl
  }
  if (receipt.fileName.startsWith('merged/')) {
    const mergedFileName = receipt.fileName.replace('merged/', '')
    return `/api/scan/image/${props.mCode}/merged/${mergedFileName}`
  }
  return `/api/scan/image/${props.mCode}/${receipt.fileName}`
}

// 스낵바 표시
const showSnackbar = (message: string, color: string = 'error') => {
  snackbarMessage.value = message
  snackbarColor.value = color
  snackbar.value = true
}

// 영수증 이미지 미리보기 열기
const openReceiptPreview = (receipt: Receipt) => {
  previewCurrentReceipt.value = receipt
  receiptPreviewUrl.value = getReceiptImageUrl(receipt)
  receiptPreviewName.value = receipt.description || receipt.fileName
  previewZoom.value = 0.75  // 줌 초기화 (75%)
  
  // 현재 영수증의 인덱스 찾기
  const list = filteredAndSortedReceipts.value
  const idx = list.findIndex(r => r.fileName === receipt.fileName)
  previewReceiptIndex.value = idx >= 0 ? idx : 0
  
  receiptPreviewDialog.value = true
}

// 미리보기에서 이전 영수증
const prevPreviewReceipt = () => {
  const list = filteredAndSortedReceipts.value
  if (list.length === 0) return
  
  previewReceiptIndex.value = (previewReceiptIndex.value - 1 + list.length) % list.length
  const receipt = list[previewReceiptIndex.value]
  previewCurrentReceipt.value = receipt
  receiptPreviewUrl.value = getReceiptImageUrl(receipt)
  receiptPreviewName.value = receipt.description || receipt.fileName
}

// 미리보기에서 다음 영수증
const nextPreviewReceipt = () => {
  const list = filteredAndSortedReceipts.value
  if (list.length === 0) return
  
  previewReceiptIndex.value = (previewReceiptIndex.value + 1) % list.length
  const receipt = list[previewReceiptIndex.value]
  previewCurrentReceipt.value = receipt
  receiptPreviewUrl.value = getReceiptImageUrl(receipt)
  receiptPreviewName.value = receipt.description || receipt.fileName
}

// 미리보기에서 캔버스로 바로 추가
const previewToCrop = async () => {
  const receipt = previewCurrentReceipt.value
  if (!receipt) return
  receiptPreviewDialog.value = false
  await handleReceiptClick(receipt)
}

// 미리보기에서 캔버스에 추가 (호환)
const addPreviewReceiptToCanvas = async () => {
  await previewToCrop()
}

// 영수증 수정 모달 열기
const openReceiptEditModal = (receipt: Receipt | null) => {
  if (!receipt) return
  editingReceipt.value = {
    ...receipt,
    mCode: props.mCode
  }
  receiptEditModalVisible.value = true
}

// 영수증 수정 완료 후 새로고침
const onReceiptEditSaved = async () => {
  // 수정 전 영수증의 fileName 저장
  const editedFileName = editingReceipt.value?.fileName
  
  await loadUnmatchedReceipts()
  
  // 미리보기 다이얼로그가 열려있으면 정보 업데이트
  if (receiptPreviewDialog.value && editedFileName) {
    const updated = filteredAndSortedReceipts.value.find(r => r.fileName === editedFileName)
    if (updated) {
      previewCurrentReceipt.value = updated
      receiptPreviewUrl.value = getReceiptImageUrl(updated)
      receiptPreviewName.value = updated.description || updated.fileName
      // 인덱스 업데이트 (날짜 변경으로 정렬 순서가 바뀔 수 있음)
      const newIndex = filteredAndSortedReceipts.value.findIndex(r => r.fileName === editedFileName)
      if (newIndex >= 0) {
        previewReceiptIndex.value = newIndex
      }
    }
  }
  
  // 성공 메시지
  showSnackbar('영수증이 수정되었습니다.', 'success')
}

// 줌 인
const zoomIn = () => {
  if (previewZoom.value < 3) {
    previewZoom.value = Math.min(previewZoom.value + 0.25, 3)
  }
}

// 줌 아웃
const zoomOut = () => {
  if (previewZoom.value > 0.25) {
    previewZoom.value = Math.max(previewZoom.value - 0.25, 0.25)
  }
}

// 줌 리셋 (75%로 리셋)
const resetZoom = () => {
  previewZoom.value = 0.75
}

// Watch — 로드 함수 정의 이후 등록 (immediate TDZ 방지)
watch(isActive, async (active) => {
  if (active) {
    await bootstrapMatching()
  } else {
    disposeAllCanvases()
  }
}, { immediate: true })

watch(() => props.modelValue, (val) => {
  if (props.embedded) return
  if (dialogOpen.value !== val) dialogOpen.value = val
})

watch(
  () => [props.currentYear, props.currentMonth, props.mCode, props.bizGubun] as const,
  async () => {
    if (props.embedded && isActive.value) {
      await bootstrapMatching()
    }
  }
)

watch(() => props.cashbookItem?.cb_idx, async () => {
  if (props.embedded && isActive.value && props.cashbookItem) {
    await applyCashbookItemSelection()
  }
})

// 컴포넌트 언마운트 시 정리
onBeforeUnmount(() => {
  destroyCropper()
  disposeAllCanvases()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.embedded ? 'div' : 'v-dialog'), _mergeProps(wrapperBind.value, { "onUpdate:modelValue": onWrapperModelUpdate }), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["matching-modal-fullscreen", { embedded: __props.embedded }]),
        onKeydown: handleKeydown,
        tabindex: "0",
        ref_key: "modalRef",
        ref: modalRef
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["matching-header", { page: __props.embedded }])
        }, [
          (!__props.embedded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  size: "24",
                  color: "white"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("mdi-link-variant", -1)
                  ]))]),
                  _: 1
                }),
                _cache[22] || (_cache[22] = _createElementVNode("h2", null, "영수증 매칭", -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (selectedCashbookItems.value.length === 0 && totalReceiptsInCanvas.value === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 왼쪽 지출을 고르고, 가운데 영수증을 누른 뒤 오른쪽 「매칭」을 누르세요. 날짜가 달라도 맞출 수 있고, 그때는 저장 전에 한 번 확인합니다. "))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_4, [
            (selectedCashbookItems.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    color: __props.embedded ? '#64748b' : '#60a5fa'
                  }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createTextVNode("mdi-book-open-page-variant", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color"]),
                  _createTextVNode(" 통장 " + _toDisplayString(selectedCashbookItems.value.length) + "건 ", 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(formatNumber(selectedTotal.value)) + "원", 1)
                ]))
              : _createCommentVNode("", true),
            (selectedCashbookItems.value.length > 0 && totalReceiptsInCanvas.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createVNode(_component_v_icon, {
                    size: "18",
                    color: "#94a3b8"
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("mdi-arrow-right", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (totalReceiptsInCanvas.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    color: __props.embedded ? '#64748b' : '#94a3b8'
                  }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode("mdi-receipt", -1)
                    ]))]),
                    _: 1
                  }, 8, ["color"]),
                  _createTextVNode(" 영수증 " + _toDisplayString(totalReceiptsInCanvas.value) + "장 ", 1),
                  (canvasPages.value.length > 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(canvasPages.value.length) + "페이지)", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (!__props.embedded)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "close-btn",
                  onClick: closeDialog
                }, [
                  _createVNode(_component_v_icon, { size: "22" }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createTextVNode("mdi-book-open-page-variant", -1)
                ]))]),
                _: 1
              }),
              _cache[28] || (_cache[28] = _createElementVNode("span", null, "통장내역", -1)),
              (selectedCashbookItems.value.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(selectedCashbookItems.value.length) + "선택", 1))
                : _createCommentVNode("", true),
              (selectedCashbookItems.value.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "clear-sel-btn",
                    title: "선택 해제",
                    onClick: clearCashbookSelection
                  }, " 해제 "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn", { active: cashbookFilterMatched.value === 'unmatched' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (cashbookFilterMatched.value = 'unmatched'))
              }, [
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createTextVNode("mdi-link-variant-off", -1)
                  ]))]),
                  _: 1
                }),
                _cache[30] || (_cache[30] = _createTextVNode(" 미매칭 ", -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(unmatchedCashbookCount.value), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn matched", { active: cashbookFilterMatched.value === 'matched' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (cashbookFilterMatched.value = 'matched'))
              }, [
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode("mdi-link-variant", -1)
                  ]))]),
                  _: 1
                }),
                _cache[32] || (_cache[32] = _createTextVNode(" 매칭완료 ", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(matchedCashbookCount.value), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn all", { active: cashbookFilterMatched.value === '' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (cashbookFilterMatched.value = ''))
              }, [
                _cache[33] || (_cache[33] = _createTextVNode(" 전체 ", -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(cashbookListForMatching.value.length), 1)
              ], 2)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["cashbook-list", { 'has-selection': selectedCashbookItems.value.length > 0 || !!selectedFilterDate.value }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCashbookByDate.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.cb_idx,
                  class: _normalizeClass(["cashbook-item", { 
                selected: isCashbookItemSelected(item),
                matched: isCashbookReceiptMatched(item),
                'date-blocked': isCashbookDateBlocked(item),
                'date-diff': isCashbookDateDifferent(item)
              }]),
                  title: cashbookSelectHint(item),
                  onClick: ($event: any) => (toggleCashbookItem(item))
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: isCashbookItemSelected(item) ? '#1e3a5f' : '#cbd5e1'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(isCashbookItemSelected(item) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createTextVNode(_toDisplayString(formatShortDate(item.cb_date)) + " ", 1),
                        (isCashbookDateDifferent(item))
                          ? (_openBlock(), _createElementBlock("em", _hoisted_24, "날짜다름"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(formatNumber(item.cb_price)) + "원", 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(item.cb_memo || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (isCashbookReceiptMatched(item))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "16",
                          color: "#64748b",
                          title: "영수증 매칭됨"
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createTextVNode("mdi-receipt-text-check", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_19))
              }), 128)),
              (loadingCashbook.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      size: "24",
                      color: "#1e3a5f"
                    }),
                    _cache[35] || (_cache[35] = _createElementVNode("span", null, "불러오는 중...", -1))
                  ]))
                : (filteredCashbookByDate.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createVNode(_component_v_icon, {
                        size: "32",
                        color: "#94a3b8"
                      }, {
                        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                          _createTextVNode("mdi-file-document-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(selectedReceiptDate.value ? '해당 날짜의 통장내역이 없습니다' : (cashbookFilterMatched.value === 'unmatched' ? '미매칭 항목이 없습니다' : cashbookFilterMatched.value === 'matched' ? '매칭된 항목이 없습니다' : '항목이 없습니다')), 1)
                    ]))
                  : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                  _createTextVNode("mdi-receipt", -1)
                ]))]),
                _: 1
              }),
              _cache[38] || (_cache[38] = _createElementVNode("span", null, "영수증", -1)),
              _createElementVNode("span", _hoisted_32, _toDisplayString(filteredAndSortedReceipts.value.length), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn", { active: receiptFilterMatched.value === 'unmatched' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (receiptFilterMatched.value = 'unmatched'))
              }, [
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode("mdi-link-variant-off", -1)
                  ]))]),
                  _: 1
                }),
                _cache[40] || (_cache[40] = _createTextVNode(" 미매칭 ", -1)),
                _createElementVNode("span", _hoisted_34, _toDisplayString(unmatchedReceiptCount.value), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn matched", { active: receiptFilterMatched.value === 'matched' }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (receiptFilterMatched.value = 'matched'))
              }, [
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                    _createTextVNode("mdi-link-variant", -1)
                  ]))]),
                  _: 1
                }),
                _cache[42] || (_cache[42] = _createTextVNode(" 매칭완료 ", -1)),
                _createElementVNode("span", _hoisted_35, _toDisplayString(matchedReceiptCount.value), 1)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["tab-btn all", { active: receiptFilterMatched.value === '' }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (receiptFilterMatched.value = ''))
              }, [
                _cache[43] || (_cache[43] = _createTextVNode(" 전체 ", -1)),
                _createElementVNode("span", _hoisted_36, _toDisplayString(currentMonthReceipts.value.length), 1)
              ], 2)
            ]),
            _createElementVNode("div", {
              class: "receipt-list",
              ref_key: "thumbnailTrack",
              ref: thumbnailTrack
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAndSortedReceipts.value, (receipt) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: receipt.fileName
                }, [
                  (isMergedReceipt(receipt))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["receipt-item merged", { 
                    'in-canvas': isReceiptInAnyCanvas(receipt),
                    'current-matched': receipt.isCurrentMatched,
                    'other-matched': receipt.matched === 1 && !receipt.isCurrentMatched,
                    'expanded': expandedMergedReceipts.value.has(receipt.fileName),
                    'loading': loadingReceiptFile.value === receipt.fileName,
                    'date-mismatch': !!selectedFilterDate.value && !isReceiptSameDateAsSelected(receipt)
                  }]),
                          title: (!!selectedFilterDate.value && !isReceiptSameDateAsSelected(receipt)) ? '날짜가 다릅니다. 선택하면 매칭할 수 있습니다' : undefined,
                          onClick: ($event: any) => (handleReceiptClick(receipt))
                        }, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("img", {
                                src: getReceiptImageUrl(receipt),
                                alt: receipt.fileName
                              }, null, 8, _hoisted_41),
                              (isReceiptInAnyCanvas(receipt))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(getReceiptCanvasIndex(receipt)), 1))
                                : _createCommentVNode("", true),
                              (isReceiptInAnyCanvas(receipt))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _createVNode(_component_v_icon, {
                                      size: "16",
                                      color: "white"
                                    }, {
                                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                        _createTextVNode("mdi-check", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (loadingReceiptFile.value === receipt.fileName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createVNode(_component_v_progress_circular, {
                                      indeterminate: "",
                                      size: "20",
                                      width: "2",
                                      color: "white"
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createTextVNode(_toDisplayString(formatReceiptDate(receipt.scanDate)) + " ", 1),
                                (selectedFilterDate.value && !isReceiptSameDateAsSelected(receipt))
                                  ? (_openBlock(), _createElementBlock("em", _hoisted_47, "날짜다름"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", {
                                class: "item-desc",
                                title: receipt.description || ''
                              }, _toDisplayString(formatReceiptMemo(receipt.description)), 9, _hoisted_48),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("span", _hoisted_50, [
                                  _createVNode(_component_v_icon, { size: "10" }, {
                                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                      _createTextVNode("mdi-folder-multiple-image", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[46] || (_cache[46] = _createTextVNode(" 합성 ", -1))
                                ]),
                                ((receipt.matchCount ?? 0) > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                      _createVNode(_component_v_icon, { size: "10" }, {
                                        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                          _createTextVNode("mdi-link-variant", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(receipt.matchCount) + "건 ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("button", {
                              class: "merged-action-btn preview",
                              onClick: _withModifiers(($event: any) => (openReceiptPreview(receipt)), ["stop"]),
                              title: "이미지 보기"
                            }, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                  _createTextVNode("mdi-eye-outline", -1)
                                ]))]),
                                _: 1
                              })
                            ], 8, _hoisted_53),
                            _createElementVNode("button", {
                              class: "merged-action-btn view",
                              onClick: _withModifiers(($event: any) => (toggleMergedExpand(receipt)), ["stop"]),
                              title: expandedMergedReceipts.value.has(receipt.fileName) ? '원본 접기' : '영수증 펼쳐보기'
                            }, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(expandedMergedReceipts.value.has(receipt.fileName) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", _hoisted_55, _toDisplayString(expandedMergedReceipts.value.has(receipt.fileName) ? '접기' : '펼쳐보기'), 1)
                            ], 8, _hoisted_54),
                            _createElementVNode("button", {
                              class: "merged-action-btn delete",
                              onClick: _withModifiers(($event: any) => (confirmDeleteMergedReceipt(receipt)), ["stop"]),
                              title: "삭제"
                            }, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                  _createTextVNode("mdi-delete-outline", -1)
                                ]))]),
                                _: 1
                              })
                            ], 8, _hoisted_56)
                          ])
                        ], 10, _hoisted_38),
                        (expandedMergedReceipts.value.has(receipt.fileName))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getChildReceipts(receipt), (childReceipt) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: childReceipt.fileName,
                                  class: _normalizeClass(["receipt-item child", {
                      'in-canvas': isReceiptInAnyCanvas(childReceipt),
                      'date-mismatch': !!selectedFilterDate.value && !isReceiptSameDateAsSelected(childReceipt)
                    }]),
                                  title: (!!selectedFilterDate.value && !isReceiptSameDateAsSelected(childReceipt)) ? '날짜가 다릅니다. 선택하면 매칭할 수 있습니다' : undefined
                                }, [
                                  _createElementVNode("div", {
                                    class: "item-content",
                                    onClick: ($event: any) => (handleReceiptClick(childReceipt))
                                  }, [
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("img", {
                                        src: getReceiptImageUrl(childReceipt),
                                        alt: childReceipt.fileName
                                      }, null, 8, _hoisted_61),
                                      (isReceiptInAnyCanvas(childReceipt))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _createVNode(_component_v_icon, {
                                              size: "16",
                                              color: "white"
                                            }, {
                                              default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                                _createTextVNode("mdi-check", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("div", {
                                        class: "item-desc",
                                        title: childReceipt.description || ''
                                      }, _toDisplayString(formatReceiptMemo(childReceipt.description)), 9, _hoisted_64)
                                    ])
                                  ], 8, _hoisted_59),
                                  _createElementVNode("button", {
                                    class: "preview-btn",
                                    onClick: _withModifiers(($event: any) => (openReceiptPreview(childReceipt)), ["stop"])
                                  }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                        _createTextVNode("mdi-eye-outline", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_65)
                                ], 10, _hoisted_58))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["receipt-item normal", { 
                  'in-canvas': isReceiptInAnyCanvas(receipt),
                  'current-matched': receipt.isCurrentMatched,
                  'other-matched': receipt.matched === 1 && !receipt.isCurrentMatched,
                  'loading': loadingReceiptFile.value === receipt.fileName,
                  'date-mismatch': !!selectedFilterDate.value && !isReceiptSameDateAsSelected(receipt)
                }]),
                        title: (!!selectedFilterDate.value && !isReceiptSameDateAsSelected(receipt)) ? '날짜가 다릅니다. 선택하면 매칭할 수 있습니다' : undefined,
                        onClick: ($event: any) => (handleReceiptClick(receipt))
                      }, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("img", {
                              src: getReceiptImageUrl(receipt),
                              alt: receipt.fileName
                            }, null, 8, _hoisted_69),
                            (isReceiptInAnyCanvas(receipt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(getReceiptCanvasIndex(receipt)), 1))
                              : _createCommentVNode("", true),
                            (isReceiptInAnyCanvas(receipt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  _createVNode(_component_v_icon, {
                                    size: "16",
                                    color: "white"
                                  }, {
                                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                      _createTextVNode("mdi-check", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (loadingReceiptFile.value === receipt.fileName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    size: "20",
                                    width: "2",
                                    color: "white"
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createTextVNode(_toDisplayString(formatReceiptDate(receipt.scanDate)) + " ", 1),
                              (selectedFilterDate.value && !isReceiptSameDateAsSelected(receipt))
                                ? (_openBlock(), _createElementBlock("em", _hoisted_75, "날짜다름"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: "item-desc",
                              title: receipt.description || ''
                            }, _toDisplayString(formatReceiptMemo(receipt.description)), 9, _hoisted_76),
                            ((receipt.matchCount ?? 0) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  _createVNode(_component_v_icon, { size: "12" }, {
                                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                      _createTextVNode("mdi-link-variant", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(receipt.matchCount) + "건 매칭 ", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("button", {
                            class: "preview-btn",
                            onClick: _withModifiers(($event: any) => (openReceiptPreview(receipt)), ["stop"]),
                            title: "미리보기"
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                _createTextVNode("mdi-eye-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_79),
                          _createElementVNode("button", {
                            class: "edit-btn",
                            onClick: _withModifiers(($event: any) => (openReceiptEditModal(receipt)), ["stop"]),
                            title: "날짜·적요 수정"
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                _createTextVNode("mdi-pencil-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_80)
                        ])
                      ], 10, _hoisted_66))
                ], 64))
              }), 128)),
              (filteredAndSortedReceipts.value.length === 0 && !loadingReceipts.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createVNode(_component_v_icon, {
                      size: "32",
                      color: "#94a3b8"
                    }, {
                      default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                        _createTextVNode("mdi-receipt-text-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(props.currentYear) + "년 " + _toDisplayString(props.currentMonth) + "월 영수증이 없습니다", 1),
                    _cache[57] || (_cache[57] = _createElementVNode("span", { class: "empty-sub" }, "앱에 올린 영수증은 저장할 때 적은 날짜의 달에 나타납니다", -1))
                  ]))
                : _createCommentVNode("", true),
              (loadingReceipts.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      size: "24",
                      color: "#1e3a5f"
                    }),
                    _cache[58] || (_cache[58] = _createElementVNode("span", null, "불러오는 중...", -1))
                  ]))
                : _createCommentVNode("", true)
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_83, [
            (!isAlreadyMatched.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(canvasPages.value, (page, idx) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: page.id,
                        class: _normalizeClass(["page-btn", { active: currentPageIndex.value === idx }]),
                        onClick: ($event: any) => (switchToPage(idx)),
                        title: `${idx + 1}페이지 (${page.receipts.length}장)`
                      }, [
                        _createElementVNode("span", _hoisted_87, _toDisplayString(idx + 1), 1),
                        (page.receipts.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(page.receipts.length), 1))
                          : _createCommentVNode("", true),
                        (canvasPages.value.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "page-remove-btn",
                              onClick: _withModifiers(($event: any) => (removePage(idx)), ["stop"]),
                              title: "페이지 삭제"
                            }, [
                              _createVNode(_component_v_icon, { size: "10" }, {
                                default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                  _createTextVNode("mdi-close", -1)
                                ]))]),
                                _: 1
                              })
                            ], 8, _hoisted_89))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_86))
                    }), 128)),
                    _createElementVNode("button", {
                      class: "page-btn add",
                      onClick: addNewPage,
                      title: "페이지 추가"
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                          _createTextVNode("mdi-plus", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("span", _hoisted_91, [
                      _createVNode(_component_v_icon, { size: "12" }, {
                        default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                          _createTextVNode("mdi-content-cut", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[62] || (_cache[62] = _createTextVNode(" 통장 → 영수증 → 매칭 ", -1))
                    ]),
                    (crossDateHint.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(crossDateHint.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_93, [
                      _createVNode(_component_v_icon, { size: "12" }, {
                        default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                          _createTextVNode("mdi-file-multiple", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(totalReceiptsInCanvas.value) + "장 ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("button", {
                      class: "toolbar-btn delete",
                      onClick: deleteSelectedFromCanvas,
                      disabled: !hasSelectedObject.value,
                      title: "선택 삭제 (Del)"
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                          _createTextVNode("mdi-delete", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_95),
                    _createElementVNode("button", {
                      class: "toolbar-btn clear",
                      onClick: clearAllCanvases,
                      disabled: totalReceiptsInCanvas.value === 0,
                      title: "전체 삭제"
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                          _createTextVNode("mdi-delete-sweep", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_96),
                    _createElementVNode("button", {
                      class: "toolbar-btn save",
                      onClick: openMergedNameDialog,
                      disabled: totalReceiptsInCanvas.value === 0 || selectedCashbookItems.value.length === 0 || saving.value || hasMatchedInSelection.value,
                      title: "매칭 저장 (2장 이상이면 한 장으로 합성)"
                    }, [
                      (saving.value)
                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                            key: 0,
                            indeterminate: "",
                            size: "14",
                            width: "2",
                            color: "white"
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                                _createTextVNode("mdi-link-variant", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(totalReceiptsInCanvas.value >= 2 ? '묶어서 매칭' : '매칭'), 1)
                          ], 64))
                    ], 8, _hoisted_97)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!isAlreadyMatched.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  _createElementVNode("div", {
                    class: "canvas-wrapper",
                    ref_key: "canvasWrapperRef",
                    ref: canvasWrapperRef
                  }, [
                    (canvasPages.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _createElementVNode("canvas", {
                            ref_key: "fabricCanvasRef",
                            ref: fabricCanvasRef
                          }, null, 512)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_100, [
                          _createVNode(_component_v_icon, {
                            size: "48",
                            color: "#cbd5e1"
                          }, {
                            default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                              _createTextVNode("mdi-file-image-plus-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[68] || (_cache[68] = _createElementVNode("p", null, "가운데 영수증을 누르면 캔버스에 들어갑니다", -1)),
                          _cache[69] || (_cache[69] = _createElementVNode("p", { class: "empty-canvas-sub" }, "날짜가 달라도 함께 고를 수 있습니다. 저장할 때 한 번 확인합니다", -1))
                        ]))
                  ], 512)
                ]))
              : (isAlreadyMatched.value && existingMatching.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("span", _hoisted_103, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          color: "#94a3b8"
                        }, {
                          default: _withCtx(() => [...(_cache[70] || (_cache[70] = [
                            _createTextVNode("mdi-link-variant", -1)
                          ]))]),
                          _: 1
                        }),
                        _createTextVNode(" 매칭됨 · " + _toDisplayString(matchedImages.value.length) + "장 ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("button", {
                          class: "toolbar-btn unmatch",
                          onClick: unmatchReceipt,
                          disabled: saving.value
                        }, [
                          (saving.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                size: "14",
                                width: "2",
                                color: "white"
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                                    _createTextVNode("mdi-link-variant-off", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[72] || (_cache[72] = _createElementVNode("span", null, "해제", -1))
                              ], 64))
                        ], 8, _hoisted_105)
                      ])
                    ]),
                    _cache[81] || (_cache[81] = _createElementVNode("p", { class: "rematch-hint" }, "맞춘 영수증은 편집할 수 없습니다. 다시 자르거나 묶으려면 먼저 「해제」하세요.", -1)),
                    (mergedMatchedImages.value.length > 0 && sourceMatchedImages.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["tab-btn", { active: matchedImageTab.value === 'merged' }]),
                            onClick: _cache[6] || (_cache[6] = ($event: any) => {matchedImageTab.value = 'merged'; previewImageType.value = 'merged'; previewImageIndex.value = 0})
                          }, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                _createTextVNode("mdi-folder-multiple-image", -1)
                              ]))]),
                              _: 1
                            }),
                            _createTextVNode(" 합성 (" + _toDisplayString(mergedMatchedImages.value.length) + ") ", 1)
                          ], 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["tab-btn", { active: matchedImageTab.value === 'source' }]),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => {matchedImageTab.value = 'source'; previewImageType.value = 'source'; previewImageIndex.value = 0})
                          }, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                _createTextVNode("mdi-receipt-text-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _createTextVNode(" 원본 (" + _toDisplayString(sourceMatchedImages.value.length) + ") ", 1)
                          ], 2)
                        ]))
                      : (mergedMatchedImages.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                _createTextVNode("mdi-folder-multiple-image", -1)
                              ]))]),
                              _: 1
                            }),
                            _createTextVNode(" 합성 영수증 " + _toDisplayString(mergedMatchedImages.value.length) + "장 ", 1)
                          ]))
                        : (sourceMatchedImages.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                  _createTextVNode("mdi-receipt-text-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" 영수증 " + _toDisplayString(sourceMatchedImages.value.length) + "장 ", 1)
                            ]))
                          : _createCommentVNode("", true),
                    ((matchedImageTab.value === 'merged' || sourceMatchedImages.value.length === 0) && mergedMatchedImages.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mergedMatchedImages.value, (img, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: img.fileName,
                              class: _normalizeClass(["matched-image-item merged", { active: previewImageType.value === 'merged' && previewImageIndex.value === idx }]),
                              onClick: ($event: any) => (selectPreviewImage('merged', idx))
                            }, [
                              _createElementVNode("img", {
                                src: getReceiptImageUrl(img),
                                alt: img.fileName
                              }, null, 8, _hoisted_111),
                              (previewImageType.value === 'merged' && previewImageIndex.value === idx)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      color: "white"
                                    }, {
                                      default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                        _createTextVNode("mdi-eye", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[78] || (_cache[78] = _createElementVNode("div", { class: "item-badge merged" }, "합성", -1))
                            ], 10, _hoisted_110))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    ((matchedImageTab.value === 'source' || mergedMatchedImages.value.length === 0) && sourceMatchedImages.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceMatchedImages.value, (img, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: img.fileName,
                              class: _normalizeClass(["matched-image-item source", { active: previewImageType.value === 'source' && previewImageIndex.value === idx }]),
                              onClick: ($event: any) => (selectPreviewImage('source', idx))
                            }, [
                              _createElementVNode("img", {
                                src: getReceiptImageUrl(img),
                                alt: img.fileName
                              }, null, 8, _hoisted_115),
                              (previewImageType.value === 'source' && previewImageIndex.value === idx)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      color: "white"
                                    }, {
                                      default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                        _createTextVNode("mdi-eye", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _cache[80] || (_cache[80] = _createElementVNode("div", { class: "item-badge source" }, "원본", -1))
                            ], 10, _hoisted_114))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (currentPreviewImage.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                          _createElementVNode("img", {
                            src: getReceiptImageUrl(currentPreviewImage.value)
                          }, null, 8, _hoisted_118)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
            (loadingReceipts.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "#1e3a5f",
                    size: "40"
                  }),
                  _cache[82] || (_cache[82] = _createElementVNode("span", null, "영수증 불러오는 중...", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 34),
      _createVNode(_component_v_dialog, {
        modelValue: deleteMergedDialog.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((deleteMergedDialog).value = $event)),
        "max-width": "400",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "merged-delete-dialog" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6 merged-delete-dialog__title" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_120, [
                    _createVNode(_component_v_icon, {
                      color: "error",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                        _createTextVNode("mdi-alert-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[84] || (_cache[84] = _createTextVNode(" 합성 영수증 삭제 ", -1))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "merged-delete-dialog__close",
                    disabled: deletingMerged.value,
                    "aria-label": "닫기",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => {deleteMergedDialog.value = false; receiptToDelete.value = null})
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_121)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[86] || (_cache[86] = _createElementVNode("p", null, "이 합성 영수증을 삭제하시겠습니까?", -1)),
                  _cache[87] || (_cache[87] = _createElementVNode("p", { class: "text-caption text-grey mt-2" }, " ※ 합성에 사용된 원본 영수증은 삭제되지 않습니다. ", -1)),
                  (receiptToDelete.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, _toDisplayString(formatScanDate(receiptToDelete.value.scanDate)), 1),
                        _createElementVNode("div", _hoisted_124, _toDisplayString(receiptToDelete.value.description || '-'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => {deleteMergedDialog.value = false; receiptToDelete.value = null}),
                    disabled: deletingMerged.value
                  }, {
                    default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                      _createTextVNode(" 취소 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    variant: "flat",
                    onClick: deleteMergedReceipt,
                    loading: deletingMerged.value
                  }, {
                    default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                      _createTextVNode(" 삭제 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: mergedNameDialog.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((mergedNameDialog).value = $event)),
        "max-width": "400",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "merged-name-dialog" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "dialog-title" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "20",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                      _createTextVNode("mdi-image-multiple", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[92] || (_cache[92] = _createTextVNode(" 합성 영수증 이름 ", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "merged-name-dialog__close",
                    disabled: saving.value,
                    "aria-label": "닫기",
                    onClick: cancelMergedName
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_125)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "dialog-content" }, {
                default: _withCtx(() => [
                  _cache[93] || (_cache[93] = _createElementVNode("p", { class: "dialog-desc" }, "합성 영수증의 적요(이름)를 입력하세요.", -1)),
                  _createVNode(_component_v_text_field, {
                    modelValue: mergedReceiptName.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((mergedReceiptName).value = $event)),
                    label: "적요",
                    placeholder: "예: 사무용품 구매, 식재료비 등",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    autofocus: "",
                    onKeyup: _withKeys(confirmMergedName, ["enter"])
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    class: "btn-cancel",
                    onClick: cancelMergedName
                  }, {
                    default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                      _createTextVNode(" 취소 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-save",
                    onClick: confirmMergedName,
                    loading: saving.value
                  }, {
                    default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                      _createTextVNode(" 매칭 저장 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: receiptPreviewDialog.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((receiptPreviewDialog).value = $event)),
        "max-width": "900"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "receipt-preview-dialog" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "preview-header" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_126, [
                    _createTextVNode(_toDisplayString(receiptPreviewName.value) + " ", 1),
                    (previewCurrentReceipt.value?.scanDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(formatReceiptDate(previewCurrentReceipt.value.scanDate)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_128, "(" + _toDisplayString(previewReceiptIndex.value + 1) + " / " + _toDisplayString(filteredAndSortedReceipts.value.length) + ")", 1)
                  ]),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("div", _hoisted_129, [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      size: "small",
                      onClick: zoomOut,
                      disabled: previewZoom.value <= 0.25,
                      title: "축소"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                            _createTextVNode("mdi-minus", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createElementVNode("span", _hoisted_130, _toDisplayString(Math.round(previewZoom.value * 100)) + "%", 1),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      size: "small",
                      onClick: zoomIn,
                      disabled: previewZoom.value >= 3,
                      title: "확대"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      icon: "",
                      variant: "text",
                      size: "small",
                      onClick: resetZoom,
                      title: "원래 크기"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                            _createTextVNode("mdi-refresh", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    size: "small",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (receiptPreviewDialog.value = false)),
                    title: "닫기"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "preview-content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "preview-nav-btn prev",
                    icon: "",
                    variant: "flat",
                    color: "primary",
                    onClick: prevPreviewReceipt,
                    disabled: filteredAndSortedReceipts.value.length <= 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "32" }, {
                        default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                          _createTextVNode("mdi-chevron-left", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createElementVNode("div", {
                    class: "image-container",
                    ref_key: "previewContainerRef",
                    ref: previewContainerRef
                  }, [
                    _createElementVNode("img", {
                      src: receiptPreviewUrl.value,
                      alt: receiptPreviewName.value,
                      style: _normalizeStyle({ transform: `scale(${previewZoom.value})` }),
                      draggable: "false"
                    }, null, 12, _hoisted_131)
                  ], 512),
                  _createVNode(_component_v_btn, {
                    class: "preview-nav-btn next",
                    icon: "",
                    variant: "flat",
                    color: "primary",
                    onClick: nextPreviewReceipt,
                    disabled: filteredAndSortedReceipts.value.length <= 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "32" }, {
                        default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                          _createTextVNode("mdi-chevron-right", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "preview-actions" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    "prepend-icon": "mdi-crop",
                    onClick: previewToCrop,
                    disabled: !previewCurrentReceipt.value || isReceiptInAnyCanvas(previewCurrentReceipt.value) || isReceiptMatchedFlag(previewCurrentReceipt.value),
                    title: isReceiptMatchedFlag(previewCurrentReceipt.value) ? '맞춘 영수증은 편집할 수 없습니다' : '캔버스에 넣기'
                  }, {
                    default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                      _createTextVNode(" 캔버스에 넣기 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "title"]),
                  _createVNode(_component_v_btn, {
                    color: "secondary",
                    variant: "outlined",
                    "prepend-icon": "mdi-pencil",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (openReceiptEditModal(previewCurrentReceipt.value))),
                    disabled: !previewCurrentReceipt.value,
                    title: "날짜·적요 수정"
                  }, {
                    default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                      _createTextVNode(" 수정 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  (previewCurrentReceipt.value && isReceiptInAnyCanvas(previewCurrentReceipt.value))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_132, " 이미 캔버스에 추가됨 "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ReceiptEditModal, {
        modelValue: receiptEditModalVisible.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((receiptEditModalVisible).value = $event)),
        receipt: editingReceipt.value,
        "m-code": __props.mCode,
        onSaved: onReceiptEditSaved
      }, null, 8, ["modelValue", "receipt", "m-code"]),
      _createVNode(_component_v_snackbar, {
        modelValue: snackbar.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((snackbar).value = $event)),
        color: snackbarColor.value,
        timeout: 3000,
        location: "top"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (snackbar.value = false))
          }, {
            default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
              _createTextVNode(" 닫기 ", -1)
            ]))]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(snackbarMessage.value) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"]),
      _createVNode(_component_v_dialog, {
        modelValue: cropModal.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((cropModal).value = $event)),
        fullscreen: "",
        persistent: "",
        scrim: "rgba(15,23,42,0.72)"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("div", _hoisted_135, [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                    _createTextVNode("mdi-crop", -1)
                  ]))]),
                  _: 1
                }),
                _cache[106] || (_cache[106] = _createElementVNode("span", null, "영수증 자르기", -1)),
                (currentCropReceipt.value)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_136, _toDisplayString(currentCropReceipt.value.description || currentCropReceipt.value.fileName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("button", {
                  type: "button",
                  class: "rcm-btn ghost",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (rotateCrop(90))),
                  disabled: isCropping.value
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                      _createTextVNode("mdi-rotate-right", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[108] || (_cache[108] = _createTextVNode(" 회전 ", -1))
                ], 8, _hoisted_138),
                _createElementVNode("button", {
                  type: "button",
                  class: "rcm-btn ghost",
                  onClick: closeCropModal,
                  disabled: isCropping.value
                }, "취소", 8, _hoisted_139),
                _createElementVNode("button", {
                  type: "button",
                  class: "rcm-btn primary",
                  onClick: cropAndAddToCanvas,
                  disabled: isCropping.value
                }, [
                  (isCropping.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "14",
                        width: "2",
                        color: "white"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                            _createTextVNode("mdi-arrow-right-bold-box", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[110] || (_cache[110] = _createTextVNode(" 캔버스에 넣기 ", -1))
                      ], 64))
                ], 8, _hoisted_140),
                _createElementVNode("button", {
                  type: "button",
                  class: "rcm-close",
                  disabled: isCropping.value,
                  "aria-label": "닫기",
                  onClick: closeCropModal
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_141)
              ])
            ]),
            _createElementVNode("div", _hoisted_142, [
              _createElementVNode("div", _hoisted_143, [
                (currentCropReceipt.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      ref_key: "cropImageEl",
                      ref: cropImageEl,
                      src: getReceiptImageUrl(currentCropReceipt.value),
                      alt: currentCropReceipt.value.fileName,
                      class: "rcm-image",
                      onLoad: onCropImageLoad
                    }, null, 40, _hoisted_144))
                  : _createCommentVNode("", true)
              ]),
              (cropStripReceipts.value.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cropStripReceipts.value, (receipt) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: receipt.fileName,
                        type: "button",
                        class: _normalizeClass(["rcm-thumb", { on: currentCropReceipt.value?.fileName === receipt.fileName }]),
                        onClick: ($event: any) => (selectCropReceipt(receipt))
                      }, [
                        _createElementVNode("img", {
                          src: getReceiptImageUrl(receipt),
                          alt: receipt.fileName
                        }, null, 8, _hoisted_147)
                      ], 10, _hoisted_146))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 16))
}
}

})